// This file is auto-generated by @hey-api/openapi-ts

import type { Client, ClientMeta, Options as Options2, RequestResult, TDataShape } from "./client";
import { client } from "./client.gen";
import type {
  ActionsDescribeActionData,
  ActionsDescribeActionErrors,
  ActionsDescribeActionResponses,
  ActionsListActionsData,
  ActionsListActionsErrors,
  ActionsListActionsResponses,
  AgentsDefineAgentOutcomeData,
  AgentsDefineAgentOutcomeErrors,
  AgentsDefineAgentOutcomeResponses,
  AgentsGetCanvasAgentChatData,
  AgentsGetCanvasAgentChatErrors,
  AgentsGetCanvasAgentChatResponses,
  AgentsInterruptAgentChatData,
  AgentsInterruptAgentChatErrors,
  AgentsInterruptAgentChatResponses,
  AgentsListAgentChatMessagesData,
  AgentsListAgentChatMessagesErrors,
  AgentsListAgentChatMessagesResponses,
  AgentsResetCanvasAgentChatData,
  AgentsResetCanvasAgentChatErrors,
  AgentsResetCanvasAgentChatResponses,
  AgentsSendAgentChatMessageData,
  AgentsSendAgentChatMessageErrors,
  AgentsSendAgentChatMessageResponses,
  ApiKeysCreateApiKeyData,
  ApiKeysCreateApiKeyErrors,
  ApiKeysCreateApiKeyResponses,
  ApiKeysDeleteApiKeyData,
  ApiKeysDeleteApiKeyErrors,
  ApiKeysDeleteApiKeyResponses,
  ApiKeysDescribeApiKeyData,
  ApiKeysDescribeApiKeyErrors,
  ApiKeysDescribeApiKeyResponses,
  ApiKeysListApiKeysData,
  ApiKeysListApiKeysErrors,
  ApiKeysListApiKeysResponses,
  ApiKeysRegenerateApiKeyTokenData,
  ApiKeysRegenerateApiKeyTokenErrors,
  ApiKeysRegenerateApiKeyTokenResponses,
  ApiKeysUpdateApiKeyData,
  ApiKeysUpdateApiKeyErrors,
  ApiKeysUpdateApiKeyResponses,
  CanvasesCancelExecutionData,
  CanvasesCancelExecutionErrors,
  CanvasesCancelExecutionResponses,
  CanvasesCancelRunData,
  CanvasesCancelRunErrors,
  CanvasesCancelRunResponses,
  CanvasesCommitCanvasStagingData,
  CanvasesCommitCanvasStagingErrors,
  CanvasesCommitCanvasStagingResponses,
  CanvasesCreateCanvasData,
  CanvasesCreateCanvasErrors,
  CanvasesCreateCanvasMemoryNamespaceData,
  CanvasesCreateCanvasMemoryNamespaceErrors,
  CanvasesCreateCanvasMemoryNamespaceResponses,
  CanvasesCreateCanvasResponses,
  CanvasesDeleteCanvasData,
  CanvasesDeleteCanvasErrors,
  CanvasesDeleteCanvasMemoryData,
  CanvasesDeleteCanvasMemoryErrors,
  CanvasesDeleteCanvasMemoryResponses,
  CanvasesDeleteCanvasResponses,
  CanvasesDeleteCanvasStagingData,
  CanvasesDeleteCanvasStagingErrors,
  CanvasesDeleteCanvasStagingResponses,
  CanvasesDeleteNodeQueueItemData,
  CanvasesDeleteNodeQueueItemErrors,
  CanvasesDeleteNodeQueueItemResponses,
  CanvasesDescribeCanvasData,
  CanvasesDescribeCanvasErrors,
  CanvasesDescribeCanvasResponses,
  CanvasesDescribeCanvasVersionData,
  CanvasesDescribeCanvasVersionErrors,
  CanvasesDescribeCanvasVersionResponses,
  CanvasesDescribeRunData,
  CanvasesDescribeRunErrors,
  CanvasesDescribeRunResponses,
  CanvasesGetCanvasStagingData,
  CanvasesGetCanvasStagingErrors,
  CanvasesGetCanvasStagingResponses,
  CanvasesInvokeNodeExecutionHookData,
  CanvasesInvokeNodeExecutionHookErrors,
  CanvasesInvokeNodeExecutionHookResponses,
  CanvasesInvokeNodeTriggerHookData,
  CanvasesInvokeNodeTriggerHookErrors,
  CanvasesInvokeNodeTriggerHookResponses,
  CanvasesListCanvasesData,
  CanvasesListCanvasesErrors,
  CanvasesListCanvasesResponses,
  CanvasesListCanvasMemoriesData,
  CanvasesListCanvasMemoriesErrors,
  CanvasesListCanvasMemoriesResponses,
  CanvasesListCanvasVersionsData,
  CanvasesListCanvasVersionsErrors,
  CanvasesListCanvasVersionsResponses,
  CanvasesListEventExecutionsData,
  CanvasesListEventExecutionsErrors,
  CanvasesListEventExecutionsResponses,
  CanvasesListNodeEventsData,
  CanvasesListNodeEventsErrors,
  CanvasesListNodeEventsResponses,
  CanvasesListNodeExecutionsData,
  CanvasesListNodeExecutionsErrors,
  CanvasesListNodeExecutionsResponses,
  CanvasesListNodeQueueItemsData,
  CanvasesListNodeQueueItemsErrors,
  CanvasesListNodeQueueItemsResponses,
  CanvasesListRunsData,
  CanvasesListRunsErrors,
  CanvasesListRunsResponses,
  CanvasesPutCanvasStagingData,
  CanvasesPutCanvasStagingErrors,
  CanvasesPutCanvasStagingResponses,
  CanvasesReemitTriggerEventData,
  CanvasesReemitTriggerEventErrors,
  CanvasesReemitTriggerEventResponses,
  CanvasesResolveExecutionErrorsData,
  CanvasesResolveExecutionErrorsErrors,
  CanvasesResolveExecutionErrorsResponses,
  CanvasesUpdateCanvasData,
  CanvasesUpdateCanvasErrors,
  CanvasesUpdateCanvasMemoryNamespaceData,
  CanvasesUpdateCanvasMemoryNamespaceErrors,
  CanvasesUpdateCanvasMemoryNamespaceResponses,
  CanvasesUpdateCanvasPreferenceData,
  CanvasesUpdateCanvasPreferenceErrors,
  CanvasesUpdateCanvasPreferenceResponses,
  CanvasesUpdateCanvasResponses,
  FactoriesAddWorkOrderCommentData,
  FactoriesAddWorkOrderCommentErrors,
  FactoriesAddWorkOrderCommentResponses,
  FactoriesAnswerPlanningSessionSurveyData,
  FactoriesAnswerPlanningSessionSurveyErrors,
  FactoriesAnswerPlanningSessionSurveyResponses,
  FactoriesCloseWorkOrderData,
  FactoriesCloseWorkOrderErrors,
  FactoriesCloseWorkOrderResponses,
  FactoriesCreateFactoryAgentResourceData,
  FactoriesCreateFactoryAgentResourceErrors,
  FactoriesCreateFactoryAgentResourceResponses,
  FactoriesCreateFactoryAutomationData,
  FactoriesCreateFactoryAutomationErrors,
  FactoriesCreateFactoryAutomationResponses,
  FactoriesCreateFactoryData,
  FactoriesCreateFactoryErrors,
  FactoriesCreateFactoryIntakeData,
  FactoriesCreateFactoryIntakeErrors,
  FactoriesCreateFactoryIntakeResponses,
  FactoriesCreateFactoryLineData,
  FactoriesCreateFactoryLineErrors,
  FactoriesCreateFactoryLineResponses,
  FactoriesCreateFactoryPrFeedbackHandlerData,
  FactoriesCreateFactoryPrFeedbackHandlerErrors,
  FactoriesCreateFactoryPrFeedbackHandlerResponses,
  FactoriesCreateFactoryPullRequestData,
  FactoriesCreateFactoryPullRequestErrors,
  FactoriesCreateFactoryPullRequestResponses,
  FactoriesCreateFactoryResponses,
  FactoriesCreateWorkOrderArtifactData,
  FactoriesCreateWorkOrderArtifactErrors,
  FactoriesCreateWorkOrderArtifactResponses,
  FactoriesCreateWorkOrderData,
  FactoriesCreateWorkOrderErrors,
  FactoriesCreateWorkOrderResponses,
  FactoriesDeleteFactoryAgentResourceData,
  FactoriesDeleteFactoryAgentResourceErrors,
  FactoriesDeleteFactoryAgentResourceResponses,
  FactoriesDeleteFactoryAutomationData,
  FactoriesDeleteFactoryAutomationErrors,
  FactoriesDeleteFactoryAutomationResponses,
  FactoriesDeleteFactoryData,
  FactoriesDeleteFactoryErrors,
  FactoriesDeleteFactoryIntakeData,
  FactoriesDeleteFactoryIntakeErrors,
  FactoriesDeleteFactoryIntakeResponses,
  FactoriesDeleteFactoryPrFeedbackHandlerData,
  FactoriesDeleteFactoryPrFeedbackHandlerErrors,
  FactoriesDeleteFactoryPrFeedbackHandlerResponses,
  FactoriesDeleteFactoryResponses,
  FactoriesDescribeFactoryData,
  FactoriesDescribeFactoryErrors,
  FactoriesDescribeFactoryPullRequestData,
  FactoriesDescribeFactoryPullRequestErrors,
  FactoriesDescribeFactoryPullRequestMergeabilityData,
  FactoriesDescribeFactoryPullRequestMergeabilityErrors,
  FactoriesDescribeFactoryPullRequestMergeabilityResponses,
  FactoriesDescribeFactoryPullRequestResponses,
  FactoriesDescribeFactoryResponses,
  FactoriesDescribeFactoryUsageData,
  FactoriesDescribeFactoryUsageErrors,
  FactoriesDescribeFactoryUsageResponses,
  FactoriesDescribeFactoryVelocityData,
  FactoriesDescribeFactoryVelocityErrors,
  FactoriesDescribeFactoryVelocityResponses,
  FactoriesDescribePlanningSessionData,
  FactoriesDescribePlanningSessionErrors,
  FactoriesDescribePlanningSessionResponses,
  FactoriesDescribeWorkOrderData,
  FactoriesDescribeWorkOrderErrors,
  FactoriesDescribeWorkOrderResponses,
  FactoriesDisconnectFactoryAgentResourceOAuthData,
  FactoriesDisconnectFactoryAgentResourceOAuthErrors,
  FactoriesDisconnectFactoryAgentResourceOAuthResponses,
  FactoriesDispatchWorkOrderData,
  FactoriesDispatchWorkOrderErrors,
  FactoriesDispatchWorkOrderResponses,
  FactoriesEndPlanningSessionData,
  FactoriesEndPlanningSessionErrors,
  FactoriesEndPlanningSessionResponses,
  FactoriesExportFactoryWorkOrderRunUsageData,
  FactoriesExportFactoryWorkOrderRunUsageErrors,
  FactoriesExportFactoryWorkOrderRunUsageResponses,
  FactoriesFindPlanningSessionByWorkOrderData,
  FactoriesFindPlanningSessionByWorkOrderErrors,
  FactoriesFindPlanningSessionByWorkOrderResponses,
  FactoriesImportFactoryIntakeItemData,
  FactoriesImportFactoryIntakeItemErrors,
  FactoriesImportFactoryIntakeItemResponses,
  FactoriesListFactoriesData,
  FactoriesListFactoriesErrors,
  FactoriesListFactoriesResponses,
  FactoriesListFactoryAgentResourcesData,
  FactoriesListFactoryAgentResourcesErrors,
  FactoriesListFactoryAgentResourcesResponses,
  FactoriesListFactoryAgentResourceToolsData,
  FactoriesListFactoryAgentResourceToolsErrors,
  FactoriesListFactoryAgentResourceToolsResponses,
  FactoriesListFactoryAutomationsData,
  FactoriesListFactoryAutomationsErrors,
  FactoriesListFactoryAutomationsResponses,
  FactoriesListFactoryIntakeRunsData,
  FactoriesListFactoryIntakeRunsErrors,
  FactoriesListFactoryIntakeRunsResponses,
  FactoriesListFactoryIntakesData,
  FactoriesListFactoryIntakesErrors,
  FactoriesListFactoryIntakesResponses,
  FactoriesListFactoryLineRunnerModelsData,
  FactoriesListFactoryLineRunnerModelsErrors,
  FactoriesListFactoryLineRunnerModelsResponses,
  FactoriesListFactoryLlmModelsData,
  FactoriesListFactoryLlmModelsErrors,
  FactoriesListFactoryLlmModelsResponses,
  FactoriesListFactoryMcpClientsData,
  FactoriesListFactoryMcpClientsErrors,
  FactoriesListFactoryMcpClientsResponses,
  FactoriesListFactoryPrFeedbackHandlersData,
  FactoriesListFactoryPrFeedbackHandlersErrors,
  FactoriesListFactoryPrFeedbackHandlersResponses,
  FactoriesListFactoryWorkOrderRunUsageData,
  FactoriesListFactoryWorkOrderRunUsageErrors,
  FactoriesListFactoryWorkOrderRunUsageResponses,
  FactoriesListWorkOrderArtifactsData,
  FactoriesListWorkOrderArtifactsErrors,
  FactoriesListWorkOrderArtifactsResponses,
  FactoriesListWorkOrderEventsData,
  FactoriesListWorkOrderEventsErrors,
  FactoriesListWorkOrderEventsResponses,
  FactoriesListWorkOrdersData,
  FactoriesListWorkOrdersErrors,
  FactoriesListWorkOrdersResponses,
  FactoriesMaterializeFactoryAppTemplateData,
  FactoriesMaterializeFactoryAppTemplateErrors,
  FactoriesMaterializeFactoryAppTemplateResponses,
  FactoriesMaterializeFactoryAutomationDefaultsData,
  FactoriesMaterializeFactoryAutomationDefaultsErrors,
  FactoriesMaterializeFactoryAutomationDefaultsResponses,
  FactoriesMergeFactoryPullRequestData,
  FactoriesMergeFactoryPullRequestErrors,
  FactoriesMergeFactoryPullRequestResponses,
  FactoriesRefreshBacklogData,
  FactoriesRefreshBacklogErrors,
  FactoriesRefreshBacklogResponses,
  FactoriesRevokeFactoryMcpClientData,
  FactoriesRevokeFactoryMcpClientErrors,
  FactoriesRevokeFactoryMcpClientResponses,
  FactoriesSearchDependabotIntakeSetupItemsData,
  FactoriesSearchDependabotIntakeSetupItemsErrors,
  FactoriesSearchDependabotIntakeSetupItemsResponses,
  FactoriesSearchFactoryIntakeItemsData,
  FactoriesSearchFactoryIntakeItemsErrors,
  FactoriesSearchFactoryIntakeItemsResponses,
  FactoriesSelectFactoryVcsProviderRepositoryData,
  FactoriesSelectFactoryVcsProviderRepositoryErrors,
  FactoriesSelectFactoryVcsProviderRepositoryResponses,
  FactoriesSendPlanningSessionMessageData,
  FactoriesSendPlanningSessionMessageErrors,
  FactoriesSendPlanningSessionMessageResponses,
  FactoriesSendWorkOrderToBacklogData,
  FactoriesSendWorkOrderToBacklogErrors,
  FactoriesSendWorkOrderToBacklogResponses,
  FactoriesSetFactoryVisibilityData,
  FactoriesSetFactoryVisibilityErrors,
  FactoriesSetFactoryVisibilityResponses,
  FactoriesStartFactoryAgentResourceOAuthData,
  FactoriesStartFactoryAgentResourceOAuthErrors,
  FactoriesStartFactoryAgentResourceOAuthResponses,
  FactoriesSwitchFactoryModelSourceData,
  FactoriesSwitchFactoryModelSourceErrors,
  FactoriesSwitchFactoryModelSourceResponses,
  FactoriesSyncFactoryVelocityData,
  FactoriesSyncFactoryVelocityErrors,
  FactoriesSyncFactoryVelocityResponses,
  FactoriesUpdateFactoryAgentResourceData,
  FactoriesUpdateFactoryAgentResourceErrors,
  FactoriesUpdateFactoryAgentResourceResponses,
  FactoriesUpdateFactoryData,
  FactoriesUpdateFactoryErrors,
  FactoriesUpdateFactoryIntakeData,
  FactoriesUpdateFactoryIntakeErrors,
  FactoriesUpdateFactoryIntakeResponses,
  FactoriesUpdateFactoryLineData,
  FactoriesUpdateFactoryLineErrors,
  FactoriesUpdateFactoryLineResponses,
  FactoriesUpdateFactoryLlmModelsData,
  FactoriesUpdateFactoryLlmModelsErrors,
  FactoriesUpdateFactoryLlmModelsResponses,
  FactoriesUpdateFactoryOnboardingData,
  FactoriesUpdateFactoryOnboardingErrors,
  FactoriesUpdateFactoryOnboardingResponses,
  FactoriesUpdateFactoryPrFeedbackHandlerData,
  FactoriesUpdateFactoryPrFeedbackHandlerErrors,
  FactoriesUpdateFactoryPrFeedbackHandlerResponses,
  FactoriesUpdateFactoryPullRequestData,
  FactoriesUpdateFactoryPullRequestErrors,
  FactoriesUpdateFactoryPullRequestResponses,
  FactoriesUpdateFactoryRepositoryData,
  FactoriesUpdateFactoryRepositoryErrors,
  FactoriesUpdateFactoryRepositoryResponses,
  FactoriesUpdateFactoryResponses,
  FactoriesUpdateWorkOrderAssigneesData,
  FactoriesUpdateWorkOrderAssigneesErrors,
  FactoriesUpdateWorkOrderAssigneesResponses,
  FactoriesUpdateWorkOrderData,
  FactoriesUpdateWorkOrderErrors,
  FactoriesUpdateWorkOrderResponses,
  FactoriesUpdateWorkOrderStatusData,
  FactoriesUpdateWorkOrderStatusErrors,
  FactoriesUpdateWorkOrderStatusResponses,
  FilesCreateFactoryFileData,
  FilesCreateFactoryFileErrors,
  FilesCreateFactoryFileResponses,
  FilesCreateWorkOrderFileData,
  FilesCreateWorkOrderFileErrors,
  FilesCreateWorkOrderFileResponses,
  FilesListFactoryFilesData,
  FilesListFactoryFilesErrors,
  FilesListFactoryFilesResponses,
  FilesListWorkOrderFilesData,
  FilesListWorkOrderFilesErrors,
  FilesListWorkOrderFilesResponses,
  GroupsAddUserToGroupData,
  GroupsAddUserToGroupErrors,
  GroupsAddUserToGroupResponses,
  GroupsCreateGroupData,
  GroupsCreateGroupErrors,
  GroupsCreateGroupResponses,
  GroupsDeleteGroupData,
  GroupsDeleteGroupErrors,
  GroupsDeleteGroupResponses,
  GroupsDescribeGroupData,
  GroupsDescribeGroupErrors,
  GroupsDescribeGroupResponses,
  GroupsListGroupsData,
  GroupsListGroupsErrors,
  GroupsListGroupsResponses,
  GroupsListGroupUsersData,
  GroupsListGroupUsersErrors,
  GroupsListGroupUsersResponses,
  GroupsRemoveUserFromGroupData,
  GroupsRemoveUserFromGroupErrors,
  GroupsRemoveUserFromGroupResponses,
  GroupsUpdateGroupData,
  GroupsUpdateGroupErrors,
  GroupsUpdateGroupResponses,
  IntegrationsListIntegrationsData,
  IntegrationsListIntegrationsErrors,
  IntegrationsListIntegrationsResponses,
  MeConfigureVcsProviderInstallationData,
  MeConfigureVcsProviderInstallationErrors,
  MeConfigureVcsProviderInstallationResponses,
  MeCreateTokenData,
  MeCreateTokenErrors,
  MeCreateTokenResponses,
  MeDescribeLastLocationData,
  MeDescribeLastLocationErrors,
  MeDescribeLastLocationResponses,
  MeDescribeNotificationSettingsData,
  MeDescribeNotificationSettingsErrors,
  MeDescribeNotificationSettingsResponses,
  MeDescribeVcsProviderOnboardingData,
  MeDescribeVcsProviderOnboardingErrors,
  MeDescribeVcsProviderOnboardingResponses,
  MeListTokensData,
  MeListTokensErrors,
  MeListTokensResponses,
  MeMeData,
  MeMeErrors,
  MeMeResponses,
  MeRefreshVcsProviderOnboardingData,
  MeRefreshVcsProviderOnboardingErrors,
  MeRefreshVcsProviderOnboardingResponses,
  MeRegenerateTokenData,
  MeRegenerateTokenErrors,
  MeRegenerateTokenResponses,
  MeRevokeTokenData,
  MeRevokeTokenErrors,
  MeRevokeTokenResponses,
  MeSaveLastLocationData,
  MeSaveLastLocationErrors,
  MeSaveLastLocationResponses,
  MeSelectVcsProviderOnboardingIdentityData,
  MeSelectVcsProviderOnboardingIdentityErrors,
  MeSelectVcsProviderOnboardingIdentityResponses,
  MeStartVcsProviderInstallationData,
  MeStartVcsProviderInstallationErrors,
  MeStartVcsProviderInstallationResponses,
  MeUpdateNotificationSettingsData,
  MeUpdateNotificationSettingsErrors,
  MeUpdateNotificationSettingsResponses,
  MeVerifyVcsProviderInstallationsData,
  MeVerifyVcsProviderInstallationsErrors,
  MeVerifyVcsProviderInstallationsResponses,
  OrganizationsAcceptInviteLinkData,
  OrganizationsAcceptInviteLinkErrors,
  OrganizationsAcceptInviteLinkResponses,
  OrganizationsCancelOrganizationSubscriptionData,
  OrganizationsCancelOrganizationSubscriptionErrors,
  OrganizationsCancelOrganizationSubscriptionResponses,
  OrganizationsCreateBillingPortalSessionData,
  OrganizationsCreateBillingPortalSessionErrors,
  OrganizationsCreateBillingPortalSessionResponses,
  OrganizationsCreateBusinessCheckoutData,
  OrganizationsCreateBusinessCheckoutErrors,
  OrganizationsCreateBusinessCheckoutResponses,
  OrganizationsCreateHostedCreditCheckoutData,
  OrganizationsCreateHostedCreditCheckoutErrors,
  OrganizationsCreateHostedCreditCheckoutResponses,
  OrganizationsCreateIntegrationData,
  OrganizationsCreateIntegrationErrors,
  OrganizationsCreateIntegrationResponses,
  OrganizationsDeleteIntegrationData,
  OrganizationsDeleteIntegrationErrors,
  OrganizationsDeleteIntegrationResponses,
  OrganizationsDeleteOrganizationData,
  OrganizationsDeleteOrganizationErrors,
  OrganizationsDeleteOrganizationResponses,
  OrganizationsDescribeIntegrationData,
  OrganizationsDescribeIntegrationErrors,
  OrganizationsDescribeIntegrationResponses,
  OrganizationsDescribeOrganizationBillingData,
  OrganizationsDescribeOrganizationBillingErrors,
  OrganizationsDescribeOrganizationBillingResponses,
  OrganizationsDescribeOrganizationData,
  OrganizationsDescribeOrganizationErrors,
  OrganizationsDescribeOrganizationResponses,
  OrganizationsDescribeOrganizationSpendingReportData,
  OrganizationsDescribeOrganizationSpendingReportErrors,
  OrganizationsDescribeOrganizationSpendingReportResponses,
  OrganizationsDescribeOrganizationWorkspaceUsageData,
  OrganizationsDescribeOrganizationWorkspaceUsageErrors,
  OrganizationsDescribeOrganizationWorkspaceUsageResponses,
  OrganizationsGetInviteLinkData,
  OrganizationsGetInviteLinkErrors,
  OrganizationsGetInviteLinkResponses,
  OrganizationsListByokllmModelsData,
  OrganizationsListByokllmModelsErrors,
  OrganizationsListByokllmModelsResponses,
  OrganizationsListHostedCreditProductsData,
  OrganizationsListHostedCreditProductsErrors,
  OrganizationsListHostedCreditProductsResponses,
  OrganizationsListHostedLlmModelsData,
  OrganizationsListHostedLlmModelsErrors,
  OrganizationsListHostedLlmModelsResponses,
  OrganizationsListIntegrationResourcesData,
  OrganizationsListIntegrationResourcesErrors,
  OrganizationsListIntegrationResourcesResponses,
  OrganizationsListIntegrationsData,
  OrganizationsListIntegrationsErrors,
  OrganizationsListIntegrationsResponses,
  OrganizationsListOrganizationCreditGrantsData,
  OrganizationsListOrganizationCreditGrantsErrors,
  OrganizationsListOrganizationCreditGrantsResponses,
  OrganizationsListOrganizationHostedLlmModelsData,
  OrganizationsListOrganizationHostedLlmModelsErrors,
  OrganizationsListOrganizationHostedLlmModelsResponses,
  OrganizationsListOrganizationRunnerFleetsData,
  OrganizationsListOrganizationRunnerFleetsErrors,
  OrganizationsListOrganizationRunnerFleetsResponses,
  OrganizationsListSelectableLlmModelsData,
  OrganizationsListSelectableLlmModelsErrors,
  OrganizationsListSelectableLlmModelsResponses,
  OrganizationsNextIntegrationSetupStepData,
  OrganizationsNextIntegrationSetupStepErrors,
  OrganizationsNextIntegrationSetupStepResponses,
  OrganizationsPreviousIntegrationSetupStepData,
  OrganizationsPreviousIntegrationSetupStepErrors,
  OrganizationsPreviousIntegrationSetupStepResponses,
  OrganizationsRemoveUserData,
  OrganizationsRemoveUserErrors,
  OrganizationsRemoveUserResponses,
  OrganizationsResetInviteLinkData,
  OrganizationsResetInviteLinkErrors,
  OrganizationsResetInviteLinkResponses,
  OrganizationsResumeOrganizationSubscriptionData,
  OrganizationsResumeOrganizationSubscriptionErrors,
  OrganizationsResumeOrganizationSubscriptionResponses,
  OrganizationsSetUserOwnerData,
  OrganizationsSetUserOwnerErrors,
  OrganizationsSetUserOwnerResponses,
  OrganizationsSyncOrganizationBillingData,
  OrganizationsSyncOrganizationBillingErrors,
  OrganizationsSyncOrganizationBillingResponses,
  OrganizationsUpdateByokllmModelsData,
  OrganizationsUpdateByokllmModelsErrors,
  OrganizationsUpdateByokllmModelsResponses,
  OrganizationsUpdateIntegrationCapabilitiesData,
  OrganizationsUpdateIntegrationCapabilitiesErrors,
  OrganizationsUpdateIntegrationCapabilitiesResponses,
  OrganizationsUpdateIntegrationData,
  OrganizationsUpdateIntegrationErrors,
  OrganizationsUpdateIntegrationPropertyData,
  OrganizationsUpdateIntegrationPropertyErrors,
  OrganizationsUpdateIntegrationPropertyResponses,
  OrganizationsUpdateIntegrationResponses,
  OrganizationsUpdateIntegrationSecretData,
  OrganizationsUpdateIntegrationSecretErrors,
  OrganizationsUpdateIntegrationSecretResponses,
  OrganizationsUpdateInviteLinkData,
  OrganizationsUpdateInviteLinkErrors,
  OrganizationsUpdateInviteLinkResponses,
  OrganizationsUpdateOrganizationData,
  OrganizationsUpdateOrganizationErrors,
  OrganizationsUpdateOrganizationHostedLlmModelsData,
  OrganizationsUpdateOrganizationHostedLlmModelsErrors,
  OrganizationsUpdateOrganizationHostedLlmModelsResponses,
  OrganizationsUpdateOrganizationResponses,
  RolesAssignRoleData,
  RolesAssignRoleErrors,
  RolesAssignRoleResponses,
  RolesCreateRoleData,
  RolesCreateRoleErrors,
  RolesCreateRoleResponses,
  RolesDeleteRoleData,
  RolesDeleteRoleErrors,
  RolesDeleteRoleResponses,
  RolesDescribeRoleData,
  RolesDescribeRoleErrors,
  RolesDescribeRoleResponses,
  RolesListRolesData,
  RolesListRolesErrors,
  RolesListRolesResponses,
  RolesUpdateRoleData,
  RolesUpdateRoleErrors,
  RolesUpdateRoleResponses,
  RunnersCreateFleetData,
  RunnersCreateFleetErrors,
  RunnersCreateFleetResponses,
  RunnersCreateRunnerData,
  RunnersCreateRunnerErrors,
  RunnersCreateRunnerResponses,
  RunnersDeleteRunnerData,
  RunnersDeleteRunnerErrors,
  RunnersDeleteRunnerResponses,
  RunnersDescribeFleetData,
  RunnersDescribeFleetErrors,
  RunnersDescribeFleetResponses,
  RunnersDescribeRunnerData,
  RunnersDescribeRunnerErrors,
  RunnersDescribeRunnerResponses,
  RunnersGetFleetCapacityData,
  RunnersGetFleetCapacityErrors,
  RunnersGetFleetCapacityResponses,
  RunnersListFleetsData,
  RunnersListFleetsErrors,
  RunnersListFleetsResponses,
  RunnersListFleetTasksData,
  RunnersListFleetTasksErrors,
  RunnersListFleetTasksResponses,
  RunnersListRunnersData,
  RunnersListRunnersErrors,
  RunnersListRunnersResponses,
  RunnersUpdateFleetData,
  RunnersUpdateFleetErrors,
  RunnersUpdateFleetResponses,
  SecretsCreateSecretData,
  SecretsCreateSecretErrors,
  SecretsCreateSecretResponses,
  SecretsDeleteSecretData,
  SecretsDeleteSecretErrors,
  SecretsDeleteSecretKeyData,
  SecretsDeleteSecretKeyErrors,
  SecretsDeleteSecretKeyResponses,
  SecretsDeleteSecretResponses,
  SecretsDescribeSecretData,
  SecretsDescribeSecretErrors,
  SecretsDescribeSecretResponses,
  SecretsListSecretsData,
  SecretsListSecretsErrors,
  SecretsListSecretsResponses,
  SecretsSetSecretKeyData,
  SecretsSetSecretKeyErrors,
  SecretsSetSecretKeyResponses,
  SecretsUpdateSecretData,
  SecretsUpdateSecretErrors,
  SecretsUpdateSecretNameData,
  SecretsUpdateSecretNameErrors,
  SecretsUpdateSecretNameResponses,
  SecretsUpdateSecretResponses,
  TriggersDescribeTriggerData,
  TriggersDescribeTriggerErrors,
  TriggersDescribeTriggerResponses,
  TriggersListTriggersData,
  TriggersListTriggersErrors,
  TriggersListTriggersResponses,
  UsersListUsersData,
  UsersListUsersErrors,
  UsersListUsersResponses,
  WidgetsDescribeWidgetData,
  WidgetsDescribeWidgetErrors,
  WidgetsDescribeWidgetResponses,
  WidgetsListWidgetsData,
  WidgetsListWidgetsErrors,
  WidgetsListWidgetsResponses,
} from "./types.gen";

export type Options<
  TData extends TDataShape = TDataShape,
  ThrowOnError extends boolean = boolean,
  TResponse = unknown,
> = Options2<TData, ThrowOnError, TResponse> & {
  /**
   * You can provide a client instance returned by `createClient()` instead of
   * individual options. This might be also useful if you want to implement a
   * custom client.
   */
  client?: Client;
  /**
   * You can pass arbitrary values through the `meta` object. This can be
   * used to access values that aren't defined as part of the SDK function.
   */
  meta?: keyof ClientMeta extends never ? Record<string, unknown> : ClientMeta;
};

export const runnersListFleets = <ThrowOnError extends boolean = true>(
  options?: Options<RunnersListFleetsData, ThrowOnError>,
): RequestResult<RunnersListFleetsResponses, RunnersListFleetsErrors, ThrowOnError> =>
  (options?.client ?? client).get<RunnersListFleetsResponses, RunnersListFleetsErrors, ThrowOnError>({
    url: "/admin/api/installation/fleets",
    ...options,
  });

export const runnersCreateFleet = <ThrowOnError extends boolean = true>(
  options: Options<RunnersCreateFleetData, ThrowOnError>,
): RequestResult<RunnersCreateFleetResponses, RunnersCreateFleetErrors, ThrowOnError> =>
  (options.client ?? client).post<RunnersCreateFleetResponses, RunnersCreateFleetErrors, ThrowOnError>({
    url: "/admin/api/installation/fleets",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

export const runnersDescribeFleet = <ThrowOnError extends boolean = true>(
  options: Options<RunnersDescribeFleetData, ThrowOnError>,
): RequestResult<RunnersDescribeFleetResponses, RunnersDescribeFleetErrors, ThrowOnError> =>
  (options.client ?? client).get<RunnersDescribeFleetResponses, RunnersDescribeFleetErrors, ThrowOnError>({
    url: "/admin/api/installation/fleets/{fleetId}",
    ...options,
  });

export const runnersUpdateFleet = <ThrowOnError extends boolean = true>(
  options: Options<RunnersUpdateFleetData, ThrowOnError>,
): RequestResult<RunnersUpdateFleetResponses, RunnersUpdateFleetErrors, ThrowOnError> =>
  (options.client ?? client).patch<RunnersUpdateFleetResponses, RunnersUpdateFleetErrors, ThrowOnError>({
    url: "/admin/api/installation/fleets/{fleetId}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

export const runnersGetFleetCapacity = <ThrowOnError extends boolean = true>(
  options: Options<RunnersGetFleetCapacityData, ThrowOnError>,
): RequestResult<RunnersGetFleetCapacityResponses, RunnersGetFleetCapacityErrors, ThrowOnError> =>
  (options.client ?? client).get<RunnersGetFleetCapacityResponses, RunnersGetFleetCapacityErrors, ThrowOnError>({
    url: "/admin/api/installation/fleets/{fleetId}/capacity",
    ...options,
  });

export const runnersListRunners = <ThrowOnError extends boolean = true>(
  options: Options<RunnersListRunnersData, ThrowOnError>,
): RequestResult<RunnersListRunnersResponses, RunnersListRunnersErrors, ThrowOnError> =>
  (options.client ?? client).get<RunnersListRunnersResponses, RunnersListRunnersErrors, ThrowOnError>({
    url: "/admin/api/installation/fleets/{fleetId}/runners",
    ...options,
  });

export const runnersCreateRunner = <ThrowOnError extends boolean = true>(
  options: Options<RunnersCreateRunnerData, ThrowOnError>,
): RequestResult<RunnersCreateRunnerResponses, RunnersCreateRunnerErrors, ThrowOnError> =>
  (options.client ?? client).post<RunnersCreateRunnerResponses, RunnersCreateRunnerErrors, ThrowOnError>({
    url: "/admin/api/installation/fleets/{fleetId}/runners",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

export const runnersDeleteRunner = <ThrowOnError extends boolean = true>(
  options: Options<RunnersDeleteRunnerData, ThrowOnError>,
): RequestResult<RunnersDeleteRunnerResponses, RunnersDeleteRunnerErrors, ThrowOnError> =>
  (options.client ?? client).delete<RunnersDeleteRunnerResponses, RunnersDeleteRunnerErrors, ThrowOnError>({
    url: "/admin/api/installation/fleets/{fleetId}/runners/{runnerId}",
    ...options,
  });

export const runnersDescribeRunner = <ThrowOnError extends boolean = true>(
  options: Options<RunnersDescribeRunnerData, ThrowOnError>,
): RequestResult<RunnersDescribeRunnerResponses, RunnersDescribeRunnerErrors, ThrowOnError> =>
  (options.client ?? client).get<RunnersDescribeRunnerResponses, RunnersDescribeRunnerErrors, ThrowOnError>({
    url: "/admin/api/installation/fleets/{fleetId}/runners/{runnerId}",
    ...options,
  });

export const runnersListFleetTasks = <ThrowOnError extends boolean = true>(
  options: Options<RunnersListFleetTasksData, ThrowOnError>,
): RequestResult<RunnersListFleetTasksResponses, RunnersListFleetTasksErrors, ThrowOnError> =>
  (options.client ?? client).get<RunnersListFleetTasksResponses, RunnersListFleetTasksErrors, ThrowOnError>({
    url: "/admin/api/installation/fleets/{fleetId}/tasks",
    ...options,
  });

/**
 * List actions
 *
 * Returns a list of all actions
 */
export const actionsListActions = <ThrowOnError extends boolean = true>(
  options?: Options<ActionsListActionsData, ThrowOnError>,
): RequestResult<ActionsListActionsResponses, ActionsListActionsErrors, ThrowOnError> =>
  (options?.client ?? client).get<ActionsListActionsResponses, ActionsListActionsErrors, ThrowOnError>({
    url: "/api/v1/actions",
    ...options,
  });

/**
 * Describe action
 *
 * Returns an action by its name
 */
export const actionsDescribeAction = <ThrowOnError extends boolean = true>(
  options: Options<ActionsDescribeActionData, ThrowOnError>,
): RequestResult<ActionsDescribeActionResponses, ActionsDescribeActionErrors, ThrowOnError> =>
  (options.client ?? client).get<ActionsDescribeActionResponses, ActionsDescribeActionErrors, ThrowOnError>({
    url: "/api/v1/actions/{name}",
    ...options,
  });

/**
 * Get or create the user's chat for a canvas
 *
 * Returns the user's single chat session for the given canvas, provisioning it on first call. The session is permanent.
 */
export const agentsGetCanvasAgentChat = <ThrowOnError extends boolean = true>(
  options: Options<AgentsGetCanvasAgentChatData, ThrowOnError>,
): RequestResult<AgentsGetCanvasAgentChatResponses, AgentsGetCanvasAgentChatErrors, ThrowOnError> =>
  (options.client ?? client).get<AgentsGetCanvasAgentChatResponses, AgentsGetCanvasAgentChatErrors, ThrowOnError>({
    url: "/api/v1/agents/canvases/{canvasId}/chat",
    ...options,
  });

/**
 * Reset the user's chat for a canvas
 *
 * Deletes the current chat session and messages, then provisions a brand-new session. Used by the `/clear` command.
 */
export const agentsResetCanvasAgentChat = <ThrowOnError extends boolean = true>(
  options: Options<AgentsResetCanvasAgentChatData, ThrowOnError>,
): RequestResult<AgentsResetCanvasAgentChatResponses, AgentsResetCanvasAgentChatErrors, ThrowOnError> =>
  (options.client ?? client).post<AgentsResetCanvasAgentChatResponses, AgentsResetCanvasAgentChatErrors, ThrowOnError>({
    url: "/api/v1/agents/canvases/{canvasId}/chat/reset",
    ...options,
  });

/**
 * Interrupt agent execution
 *
 * Sends a user.interrupt event to stop the agent mid-execution.
 */
export const agentsInterruptAgentChat = <ThrowOnError extends boolean = true>(
  options: Options<AgentsInterruptAgentChatData, ThrowOnError>,
): RequestResult<AgentsInterruptAgentChatResponses, AgentsInterruptAgentChatErrors, ThrowOnError> =>
  (options.client ?? client).post<AgentsInterruptAgentChatResponses, AgentsInterruptAgentChatErrors, ThrowOnError>({
    url: "/api/v1/agents/chats/{chatId}/interrupt",
    ...options,
  });

/**
 * List messages older than a cursor
 *
 * Returns up to `limit` messages strictly older than `before_id`, oldest-first. Omit `before_id` to fetch the most recent page.
 */
export const agentsListAgentChatMessages = <ThrowOnError extends boolean = true>(
  options: Options<AgentsListAgentChatMessagesData, ThrowOnError>,
): RequestResult<AgentsListAgentChatMessagesResponses, AgentsListAgentChatMessagesErrors, ThrowOnError> =>
  (options.client ?? client).get<AgentsListAgentChatMessagesResponses, AgentsListAgentChatMessagesErrors, ThrowOnError>(
    { url: "/api/v1/agents/chats/{chatId}/messages", ...options },
  );

/**
 * Send a user message to the chat
 *
 * Persists the user message, forwards it to the upstream provider, and triggers an async stream of assistant events broadcast over the chat's websocket topic.
 */
export const agentsSendAgentChatMessage = <ThrowOnError extends boolean = true>(
  options: Options<AgentsSendAgentChatMessageData, ThrowOnError>,
): RequestResult<AgentsSendAgentChatMessageResponses, AgentsSendAgentChatMessageErrors, ThrowOnError> =>
  (options.client ?? client).post<AgentsSendAgentChatMessageResponses, AgentsSendAgentChatMessageErrors, ThrowOnError>({
    url: "/api/v1/agents/chats/{chatId}/messages",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Define outcome for agent
 *
 * Sends a user.define_outcome event with a rubric. The agent works toward the rubric with a grader evaluating each iteration.
 */
export const agentsDefineAgentOutcome = <ThrowOnError extends boolean = true>(
  options: Options<AgentsDefineAgentOutcomeData, ThrowOnError>,
): RequestResult<AgentsDefineAgentOutcomeResponses, AgentsDefineAgentOutcomeErrors, ThrowOnError> =>
  (options.client ?? client).post<AgentsDefineAgentOutcomeResponses, AgentsDefineAgentOutcomeErrors, ThrowOnError>({
    url: "/api/v1/agents/chats/{chatId}/outcome",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * List API keys
 *
 * Returns all API keys in the organization
 */
export const apiKeysListApiKeys = <ThrowOnError extends boolean = true>(
  options?: Options<ApiKeysListApiKeysData, ThrowOnError>,
): RequestResult<ApiKeysListApiKeysResponses, ApiKeysListApiKeysErrors, ThrowOnError> =>
  (options?.client ?? client).get<ApiKeysListApiKeysResponses, ApiKeysListApiKeysErrors, ThrowOnError>({
    url: "/api/v1/api-keys",
    ...options,
  });

/**
 * Create an API key
 *
 * Creates a new API key in the organization
 */
export const apiKeysCreateApiKey = <ThrowOnError extends boolean = true>(
  options: Options<ApiKeysCreateApiKeyData, ThrowOnError>,
): RequestResult<ApiKeysCreateApiKeyResponses, ApiKeysCreateApiKeyErrors, ThrowOnError> =>
  (options.client ?? client).post<ApiKeysCreateApiKeyResponses, ApiKeysCreateApiKeyErrors, ThrowOnError>({
    url: "/api/v1/api-keys",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Delete an API key
 *
 * Deletes an API key and removes its RBAC policies
 */
export const apiKeysDeleteApiKey = <ThrowOnError extends boolean = true>(
  options: Options<ApiKeysDeleteApiKeyData, ThrowOnError>,
): RequestResult<ApiKeysDeleteApiKeyResponses, ApiKeysDeleteApiKeyErrors, ThrowOnError> =>
  (options.client ?? client).delete<ApiKeysDeleteApiKeyResponses, ApiKeysDeleteApiKeyErrors, ThrowOnError>({
    url: "/api/v1/api-keys/{id}",
    ...options,
  });

/**
 * Describe an API key
 *
 * Returns details of a specific API key
 */
export const apiKeysDescribeApiKey = <ThrowOnError extends boolean = true>(
  options: Options<ApiKeysDescribeApiKeyData, ThrowOnError>,
): RequestResult<ApiKeysDescribeApiKeyResponses, ApiKeysDescribeApiKeyErrors, ThrowOnError> =>
  (options.client ?? client).get<ApiKeysDescribeApiKeyResponses, ApiKeysDescribeApiKeyErrors, ThrowOnError>({
    url: "/api/v1/api-keys/{id}",
    ...options,
  });

/**
 * Update an API key
 *
 * Updates the name, description, expiration, or app scope of an API key
 */
export const apiKeysUpdateApiKey = <ThrowOnError extends boolean = true>(
  options: Options<ApiKeysUpdateApiKeyData, ThrowOnError>,
): RequestResult<ApiKeysUpdateApiKeyResponses, ApiKeysUpdateApiKeyErrors, ThrowOnError> =>
  (options.client ?? client).patch<ApiKeysUpdateApiKeyResponses, ApiKeysUpdateApiKeyErrors, ThrowOnError>({
    url: "/api/v1/api-keys/{id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Regenerate API key token
 *
 * Regenerates the token for an API key
 */
export const apiKeysRegenerateApiKeyToken = <ThrowOnError extends boolean = true>(
  options: Options<ApiKeysRegenerateApiKeyTokenData, ThrowOnError>,
): RequestResult<ApiKeysRegenerateApiKeyTokenResponses, ApiKeysRegenerateApiKeyTokenErrors, ThrowOnError> =>
  (options.client ?? client).post<
    ApiKeysRegenerateApiKeyTokenResponses,
    ApiKeysRegenerateApiKeyTokenErrors,
    ThrowOnError
  >({
    url: "/api/v1/api-keys/{id}/token",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * List canvases
 *
 * Returns a list of all canvases
 */
export const canvasesListCanvases = <ThrowOnError extends boolean = true>(
  options?: Options<CanvasesListCanvasesData, ThrowOnError>,
): RequestResult<CanvasesListCanvasesResponses, CanvasesListCanvasesErrors, ThrowOnError> =>
  (options?.client ?? client).get<CanvasesListCanvasesResponses, CanvasesListCanvasesErrors, ThrowOnError>({
    url: "/api/v1/canvases",
    ...options,
  });

/**
 * Create canvas
 *
 * Creates a new canvas
 */
export const canvasesCreateCanvas = <ThrowOnError extends boolean = true>(
  options: Options<CanvasesCreateCanvasData, ThrowOnError>,
): RequestResult<CanvasesCreateCanvasResponses, CanvasesCreateCanvasErrors, ThrowOnError> =>
  (options.client ?? client).post<CanvasesCreateCanvasResponses, CanvasesCreateCanvasErrors, ThrowOnError>({
    url: "/api/v1/canvases",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * List event executions
 *
 * Returns a list of all node executions triggered by a root event
 */
export const canvasesListEventExecutions = <ThrowOnError extends boolean = true>(
  options: Options<CanvasesListEventExecutionsData, ThrowOnError>,
): RequestResult<CanvasesListEventExecutionsResponses, CanvasesListEventExecutionsErrors, ThrowOnError> =>
  (options.client ?? client).get<CanvasesListEventExecutionsResponses, CanvasesListEventExecutionsErrors, ThrowOnError>(
    { url: "/api/v1/canvases/{canvasId}/events/{eventId}/executions", ...options },
  );

/**
 * Resolve execution errors
 *
 * Marks canvas node execution errors as resolved
 */
export const canvasesResolveExecutionErrors = <ThrowOnError extends boolean = true>(
  options: Options<CanvasesResolveExecutionErrorsData, ThrowOnError>,
): RequestResult<CanvasesResolveExecutionErrorsResponses, CanvasesResolveExecutionErrorsErrors, ThrowOnError> =>
  (options.client ?? client).patch<
    CanvasesResolveExecutionErrorsResponses,
    CanvasesResolveExecutionErrorsErrors,
    ThrowOnError
  >({
    url: "/api/v1/canvases/{canvasId}/executions/resolve",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Cancel execution
 *
 * Cancels a running canvas node execution
 */
export const canvasesCancelExecution = <ThrowOnError extends boolean = true>(
  options: Options<CanvasesCancelExecutionData, ThrowOnError>,
): RequestResult<CanvasesCancelExecutionResponses, CanvasesCancelExecutionErrors, ThrowOnError> =>
  (options.client ?? client).patch<CanvasesCancelExecutionResponses, CanvasesCancelExecutionErrors, ThrowOnError>({
    url: "/api/v1/canvases/{canvasId}/executions/{executionId}/cancel",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Invoke execution hook
 *
 * Invokes a custom hook on a canvas node execution
 */
export const canvasesInvokeNodeExecutionHook = <ThrowOnError extends boolean = true>(
  options: Options<CanvasesInvokeNodeExecutionHookData, ThrowOnError>,
): RequestResult<CanvasesInvokeNodeExecutionHookResponses, CanvasesInvokeNodeExecutionHookErrors, ThrowOnError> =>
  (options.client ?? client).post<
    CanvasesInvokeNodeExecutionHookResponses,
    CanvasesInvokeNodeExecutionHookErrors,
    ThrowOnError
  >({
    url: "/api/v1/canvases/{canvasId}/executions/{executionId}/hooks/{hookName}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * List canvas memories
 *
 * Returns append-only memory records for a canvas
 */
export const canvasesListCanvasMemories = <ThrowOnError extends boolean = true>(
  options: Options<CanvasesListCanvasMemoriesData, ThrowOnError>,
): RequestResult<CanvasesListCanvasMemoriesResponses, CanvasesListCanvasMemoriesErrors, ThrowOnError> =>
  (options.client ?? client).get<CanvasesListCanvasMemoriesResponses, CanvasesListCanvasMemoriesErrors, ThrowOnError>({
    url: "/api/v1/canvases/{canvasId}/memory",
    ...options,
  });

/**
 * Create manual canvas memory namespace
 *
 * Creates a manually-managed memory namespace with the provided entries. Rejected if the namespace already has any entries.
 */
export const canvasesCreateCanvasMemoryNamespace = <ThrowOnError extends boolean = true>(
  options: Options<CanvasesCreateCanvasMemoryNamespaceData, ThrowOnError>,
): RequestResult<
  CanvasesCreateCanvasMemoryNamespaceResponses,
  CanvasesCreateCanvasMemoryNamespaceErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    CanvasesCreateCanvasMemoryNamespaceResponses,
    CanvasesCreateCanvasMemoryNamespaceErrors,
    ThrowOnError
  >({
    url: "/api/v1/canvases/{canvasId}/memory/namespaces",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Update manual canvas memory namespace
 *
 * Replaces the entries of a manually-managed memory namespace, optionally renaming it. Rejected if the namespace is node-managed.
 */
export const canvasesUpdateCanvasMemoryNamespace = <ThrowOnError extends boolean = true>(
  options: Options<CanvasesUpdateCanvasMemoryNamespaceData, ThrowOnError>,
): RequestResult<
  CanvasesUpdateCanvasMemoryNamespaceResponses,
  CanvasesUpdateCanvasMemoryNamespaceErrors,
  ThrowOnError
> =>
  (options.client ?? client).put<
    CanvasesUpdateCanvasMemoryNamespaceResponses,
    CanvasesUpdateCanvasMemoryNamespaceErrors,
    ThrowOnError
  >({
    url: "/api/v1/canvases/{canvasId}/memory/namespaces/{namespace}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Delete canvas memory entry
 *
 * Deletes one memory record by ID from a canvas
 */
export const canvasesDeleteCanvasMemory = <ThrowOnError extends boolean = true>(
  options: Options<CanvasesDeleteCanvasMemoryData, ThrowOnError>,
): RequestResult<CanvasesDeleteCanvasMemoryResponses, CanvasesDeleteCanvasMemoryErrors, ThrowOnError> =>
  (options.client ?? client).delete<
    CanvasesDeleteCanvasMemoryResponses,
    CanvasesDeleteCanvasMemoryErrors,
    ThrowOnError
  >({ url: "/api/v1/canvases/{canvasId}/memory/{memoryId}", ...options });

/**
 * List node events
 *
 * Returns a list of events for a specific canvas node
 */
export const canvasesListNodeEvents = <ThrowOnError extends boolean = true>(
  options: Options<CanvasesListNodeEventsData, ThrowOnError>,
): RequestResult<CanvasesListNodeEventsResponses, CanvasesListNodeEventsErrors, ThrowOnError> =>
  (options.client ?? client).get<CanvasesListNodeEventsResponses, CanvasesListNodeEventsErrors, ThrowOnError>({
    url: "/api/v1/canvases/{canvasId}/nodes/{nodeId}/events",
    ...options,
  });

/**
 * List node executions
 *
 * Returns a list of executions for a specific canvas node
 */
export const canvasesListNodeExecutions = <ThrowOnError extends boolean = true>(
  options: Options<CanvasesListNodeExecutionsData, ThrowOnError>,
): RequestResult<CanvasesListNodeExecutionsResponses, CanvasesListNodeExecutionsErrors, ThrowOnError> =>
  (options.client ?? client).get<CanvasesListNodeExecutionsResponses, CanvasesListNodeExecutionsErrors, ThrowOnError>({
    url: "/api/v1/canvases/{canvasId}/nodes/{nodeId}/executions",
    ...options,
  });

/**
 * List items in a node's queue
 *
 * Returns a list of items in a node's queue
 */
export const canvasesListNodeQueueItems = <ThrowOnError extends boolean = true>(
  options: Options<CanvasesListNodeQueueItemsData, ThrowOnError>,
): RequestResult<CanvasesListNodeQueueItemsResponses, CanvasesListNodeQueueItemsErrors, ThrowOnError> =>
  (options.client ?? client).get<CanvasesListNodeQueueItemsResponses, CanvasesListNodeQueueItemsErrors, ThrowOnError>({
    url: "/api/v1/canvases/{canvasId}/nodes/{nodeId}/queue",
    ...options,
  });

/**
 * Delete item from a node's queue
 *
 * Deletes a specific item in a node's queue
 */
export const canvasesDeleteNodeQueueItem = <ThrowOnError extends boolean = true>(
  options: Options<CanvasesDeleteNodeQueueItemData, ThrowOnError>,
): RequestResult<CanvasesDeleteNodeQueueItemResponses, CanvasesDeleteNodeQueueItemErrors, ThrowOnError> =>
  (options.client ?? client).delete<
    CanvasesDeleteNodeQueueItemResponses,
    CanvasesDeleteNodeQueueItemErrors,
    ThrowOnError
  >({ url: "/api/v1/canvases/{canvasId}/nodes/{nodeId}/queue/{itemId}", ...options });

/**
 * Update canvas preference
 *
 * Updates the current user's canvas preference
 */
export const canvasesUpdateCanvasPreference = <ThrowOnError extends boolean = true>(
  options: Options<CanvasesUpdateCanvasPreferenceData, ThrowOnError>,
): RequestResult<CanvasesUpdateCanvasPreferenceResponses, CanvasesUpdateCanvasPreferenceErrors, ThrowOnError> =>
  (options.client ?? client).put<
    CanvasesUpdateCanvasPreferenceResponses,
    CanvasesUpdateCanvasPreferenceErrors,
    ThrowOnError
  >({
    url: "/api/v1/canvases/{canvasId}/preference",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * List canvas runs
 *
 * Returns a list of runs for a canvas
 */
export const canvasesListRuns = <ThrowOnError extends boolean = true>(
  options: Options<CanvasesListRunsData, ThrowOnError>,
): RequestResult<CanvasesListRunsResponses, CanvasesListRunsErrors, ThrowOnError> =>
  (options.client ?? client).get<CanvasesListRunsResponses, CanvasesListRunsErrors, ThrowOnError>({
    url: "/api/v1/canvases/{canvasId}/runs",
    ...options,
  });

/**
 * Describe a run
 *
 * Returns a description of a run
 */
export const canvasesDescribeRun = <ThrowOnError extends boolean = true>(
  options: Options<CanvasesDescribeRunData, ThrowOnError>,
): RequestResult<CanvasesDescribeRunResponses, CanvasesDescribeRunErrors, ThrowOnError> =>
  (options.client ?? client).get<CanvasesDescribeRunResponses, CanvasesDescribeRunErrors, ThrowOnError>({
    url: "/api/v1/canvases/{canvasId}/runs/{runId}",
    ...options,
  });

/**
 * Cancel a run
 *
 * Requests cancellation of a run and its active work
 */
export const canvasesCancelRun = <ThrowOnError extends boolean = true>(
  options: Options<CanvasesCancelRunData, ThrowOnError>,
): RequestResult<CanvasesCancelRunResponses, CanvasesCancelRunErrors, ThrowOnError> =>
  (options.client ?? client).patch<CanvasesCancelRunResponses, CanvasesCancelRunErrors, ThrowOnError>({
    url: "/api/v1/canvases/{canvasId}/runs/{runId}/cancel",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Discard canvas staging
 *
 * Discards the current user's staged edits for a canvas
 */
export const canvasesDeleteCanvasStaging = <ThrowOnError extends boolean = true>(
  options: Options<CanvasesDeleteCanvasStagingData, ThrowOnError>,
): RequestResult<CanvasesDeleteCanvasStagingResponses, CanvasesDeleteCanvasStagingErrors, ThrowOnError> =>
  (options.client ?? client).delete<
    CanvasesDeleteCanvasStagingResponses,
    CanvasesDeleteCanvasStagingErrors,
    ThrowOnError
  >({ url: "/api/v1/canvases/{canvasId}/staging", ...options });

/**
 * Get canvas staging
 *
 * Returns the current user's staged edits for a canvas
 */
export const canvasesGetCanvasStaging = <ThrowOnError extends boolean = true>(
  options: Options<CanvasesGetCanvasStagingData, ThrowOnError>,
): RequestResult<CanvasesGetCanvasStagingResponses, CanvasesGetCanvasStagingErrors, ThrowOnError> =>
  (options.client ?? client).get<CanvasesGetCanvasStagingResponses, CanvasesGetCanvasStagingErrors, ThrowOnError>({
    url: "/api/v1/canvases/{canvasId}/staging",
    ...options,
  });

/**
 * Stage canvas spec files
 *
 * Writes staged canvas.yaml and console.yaml edits for the current user without creating a new version
 */
export const canvasesPutCanvasStaging = <ThrowOnError extends boolean = true>(
  options: Options<CanvasesPutCanvasStagingData, ThrowOnError>,
): RequestResult<CanvasesPutCanvasStagingResponses, CanvasesPutCanvasStagingErrors, ThrowOnError> =>
  (options.client ?? client).put<CanvasesPutCanvasStagingResponses, CanvasesPutCanvasStagingErrors, ThrowOnError>({
    url: "/api/v1/canvases/{canvasId}/staging",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Commit canvas staging
 *
 * Commits the current user's staged canvas.yaml and console.yaml edits as a new canvas version
 */
export const canvasesCommitCanvasStaging = <ThrowOnError extends boolean = true>(
  options: Options<CanvasesCommitCanvasStagingData, ThrowOnError>,
): RequestResult<CanvasesCommitCanvasStagingResponses, CanvasesCommitCanvasStagingErrors, ThrowOnError> =>
  (options.client ?? client).post<
    CanvasesCommitCanvasStagingResponses,
    CanvasesCommitCanvasStagingErrors,
    ThrowOnError
  >({
    url: "/api/v1/canvases/{canvasId}/staging/commit",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Re-emit trigger event
 *
 * Re-emits an existing root event from a trigger node
 */
export const canvasesReemitTriggerEvent = <ThrowOnError extends boolean = true>(
  options: Options<CanvasesReemitTriggerEventData, ThrowOnError>,
): RequestResult<CanvasesReemitTriggerEventResponses, CanvasesReemitTriggerEventErrors, ThrowOnError> =>
  (options.client ?? client).post<CanvasesReemitTriggerEventResponses, CanvasesReemitTriggerEventErrors, ThrowOnError>({
    url: "/api/v1/canvases/{canvasId}/triggers/{nodeId}/events/{eventId}/reemit",
    ...options,
  });

/**
 * Invoke trigger hook
 *
 * Invokes a custom hook on a canvas node trigger
 */
export const canvasesInvokeNodeTriggerHook = <ThrowOnError extends boolean = true>(
  options: Options<CanvasesInvokeNodeTriggerHookData, ThrowOnError>,
): RequestResult<CanvasesInvokeNodeTriggerHookResponses, CanvasesInvokeNodeTriggerHookErrors, ThrowOnError> =>
  (options.client ?? client).post<
    CanvasesInvokeNodeTriggerHookResponses,
    CanvasesInvokeNodeTriggerHookErrors,
    ThrowOnError
  >({
    url: "/api/v1/canvases/{canvasId}/triggers/{nodeId}/hooks/{hookName}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * List canvas versions
 *
 * Lists all versions for a canvas
 */
export const canvasesListCanvasVersions = <ThrowOnError extends boolean = true>(
  options: Options<CanvasesListCanvasVersionsData, ThrowOnError>,
): RequestResult<CanvasesListCanvasVersionsResponses, CanvasesListCanvasVersionsErrors, ThrowOnError> =>
  (options.client ?? client).get<CanvasesListCanvasVersionsResponses, CanvasesListCanvasVersionsErrors, ThrowOnError>({
    url: "/api/v1/canvases/{canvasId}/versions",
    ...options,
  });

/**
 * Describe canvas version
 *
 * Returns one canvas version by ID, including its workflow spec
 */
export const canvasesDescribeCanvasVersion = <ThrowOnError extends boolean = true>(
  options: Options<CanvasesDescribeCanvasVersionData, ThrowOnError>,
): RequestResult<CanvasesDescribeCanvasVersionResponses, CanvasesDescribeCanvasVersionErrors, ThrowOnError> =>
  (options.client ?? client).get<
    CanvasesDescribeCanvasVersionResponses,
    CanvasesDescribeCanvasVersionErrors,
    ThrowOnError
  >({ url: "/api/v1/canvases/{canvasId}/versions/{versionId}", ...options });

/**
 * Delete canvas
 *
 * Deletes an existing canvas
 */
export const canvasesDeleteCanvas = <ThrowOnError extends boolean = true>(
  options: Options<CanvasesDeleteCanvasData, ThrowOnError>,
): RequestResult<CanvasesDeleteCanvasResponses, CanvasesDeleteCanvasErrors, ThrowOnError> =>
  (options.client ?? client).delete<CanvasesDeleteCanvasResponses, CanvasesDeleteCanvasErrors, ThrowOnError>({
    url: "/api/v1/canvases/{id}",
    ...options,
  });

/**
 * Describe canvas
 *
 * Returns a canvas by ID
 */
export const canvasesDescribeCanvas = <ThrowOnError extends boolean = true>(
  options: Options<CanvasesDescribeCanvasData, ThrowOnError>,
): RequestResult<CanvasesDescribeCanvasResponses, CanvasesDescribeCanvasErrors, ThrowOnError> =>
  (options.client ?? client).get<CanvasesDescribeCanvasResponses, CanvasesDescribeCanvasErrors, ThrowOnError>({
    url: "/api/v1/canvases/{id}",
    ...options,
  });

/**
 * Update canvas
 *
 * Updates canvas metadata
 */
export const canvasesUpdateCanvas = <ThrowOnError extends boolean = true>(
  options: Options<CanvasesUpdateCanvasData, ThrowOnError>,
): RequestResult<CanvasesUpdateCanvasResponses, CanvasesUpdateCanvasErrors, ThrowOnError> =>
  (options.client ?? client).put<CanvasesUpdateCanvasResponses, CanvasesUpdateCanvasErrors, ThrowOnError>({
    url: "/api/v1/canvases/{id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * List factories
 *
 * Returns a list of factories
 */
export const factoriesListFactories = <ThrowOnError extends boolean = true>(
  options?: Options<FactoriesListFactoriesData, ThrowOnError>,
): RequestResult<FactoriesListFactoriesResponses, FactoriesListFactoriesErrors, ThrowOnError> =>
  (options?.client ?? client).get<FactoriesListFactoriesResponses, FactoriesListFactoriesErrors, ThrowOnError>({
    url: "/api/v1/factories",
    ...options,
  });

/**
 * Create factory
 *
 * Creates a new factory
 */
export const factoriesCreateFactory = <ThrowOnError extends boolean = true>(
  options: Options<FactoriesCreateFactoryData, ThrowOnError>,
): RequestResult<FactoriesCreateFactoryResponses, FactoriesCreateFactoryErrors, ThrowOnError> =>
  (options.client ?? client).post<FactoriesCreateFactoryResponses, FactoriesCreateFactoryErrors, ThrowOnError>({
    url: "/api/v1/factories",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * List workspace agent resources
 *
 * Returns MCP connections for a workspace. Skills are reserved for a later release.
 */
export const factoriesListFactoryAgentResources = <ThrowOnError extends boolean = true>(
  options: Options<FactoriesListFactoryAgentResourcesData, ThrowOnError>,
): RequestResult<FactoriesListFactoryAgentResourcesResponses, FactoriesListFactoryAgentResourcesErrors, ThrowOnError> =>
  (options.client ?? client).get<
    FactoriesListFactoryAgentResourcesResponses,
    FactoriesListFactoryAgentResourcesErrors,
    ThrowOnError
  >({ url: "/api/v1/factories/{factoryId}/agent-resources", ...options });

/**
 * Create a workspace agent resource
 *
 * Adds an MCP connection to the workspace catalog.
 */
export const factoriesCreateFactoryAgentResource = <ThrowOnError extends boolean = true>(
  options: Options<FactoriesCreateFactoryAgentResourceData, ThrowOnError>,
): RequestResult<
  FactoriesCreateFactoryAgentResourceResponses,
  FactoriesCreateFactoryAgentResourceErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    FactoriesCreateFactoryAgentResourceResponses,
    FactoriesCreateFactoryAgentResourceErrors,
    ThrowOnError
  >({
    url: "/api/v1/factories/{factoryId}/agent-resources",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Delete a workspace agent resource
 *
 * Removes an MCP connection and its OAuth tokens.
 */
export const factoriesDeleteFactoryAgentResource = <ThrowOnError extends boolean = true>(
  options: Options<FactoriesDeleteFactoryAgentResourceData, ThrowOnError>,
): RequestResult<
  FactoriesDeleteFactoryAgentResourceResponses,
  FactoriesDeleteFactoryAgentResourceErrors,
  ThrowOnError
> =>
  (options.client ?? client).delete<
    FactoriesDeleteFactoryAgentResourceResponses,
    FactoriesDeleteFactoryAgentResourceErrors,
    ThrowOnError
  >({ url: "/api/v1/factories/{factoryId}/agent-resources/{resourceId}", ...options });

/**
 * Update a workspace agent resource
 *
 * Updates name, enabled state, or MCP configuration.
 */
export const factoriesUpdateFactoryAgentResource = <ThrowOnError extends boolean = true>(
  options: Options<FactoriesUpdateFactoryAgentResourceData, ThrowOnError>,
): RequestResult<
  FactoriesUpdateFactoryAgentResourceResponses,
  FactoriesUpdateFactoryAgentResourceErrors,
  ThrowOnError
> =>
  (options.client ?? client).patch<
    FactoriesUpdateFactoryAgentResourceResponses,
    FactoriesUpdateFactoryAgentResourceErrors,
    ThrowOnError
  >({
    url: "/api/v1/factories/{factoryId}/agent-resources/{resourceId}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Disconnect MCP OAuth
 *
 * Revokes stored tokens when the vendor advertises a revoke endpoint.
 */
export const factoriesDisconnectFactoryAgentResourceOAuth = <ThrowOnError extends boolean = true>(
  options: Options<FactoriesDisconnectFactoryAgentResourceOAuthData, ThrowOnError>,
): RequestResult<
  FactoriesDisconnectFactoryAgentResourceOAuthResponses,
  FactoriesDisconnectFactoryAgentResourceOAuthErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    FactoriesDisconnectFactoryAgentResourceOAuthResponses,
    FactoriesDisconnectFactoryAgentResourceOAuthErrors,
    ThrowOnError
  >({
    url: "/api/v1/factories/{factoryId}/agent-resources/{resourceId}/oauth:disconnect",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Start MCP OAuth
 *
 * Discovers the MCP authorization server and returns the browser URL.
 */
export const factoriesStartFactoryAgentResourceOAuth = <ThrowOnError extends boolean = true>(
  options: Options<FactoriesStartFactoryAgentResourceOAuthData, ThrowOnError>,
): RequestResult<
  FactoriesStartFactoryAgentResourceOAuthResponses,
  FactoriesStartFactoryAgentResourceOAuthErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    FactoriesStartFactoryAgentResourceOAuthResponses,
    FactoriesStartFactoryAgentResourceOAuthErrors,
    ThrowOnError
  >({
    url: "/api/v1/factories/{factoryId}/agent-resources/{resourceId}/oauth:start",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * List MCP tools
 *
 * Calls tools/list on a connected MCP server. The result is read-only.
 */
export const factoriesListFactoryAgentResourceTools = <ThrowOnError extends boolean = true>(
  options: Options<FactoriesListFactoryAgentResourceToolsData, ThrowOnError>,
): RequestResult<
  FactoriesListFactoryAgentResourceToolsResponses,
  FactoriesListFactoryAgentResourceToolsErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    FactoriesListFactoryAgentResourceToolsResponses,
    FactoriesListFactoryAgentResourceToolsErrors,
    ThrowOnError
  >({ url: "/api/v1/factories/{factoryId}/agent-resources/{resourceId}/tools", ...options });

/**
 * Materialize a factory app template
 *
 * Builds a bundled factory app template with its installation settings
 */
export const factoriesMaterializeFactoryAppTemplate = <ThrowOnError extends boolean = true>(
  options: Options<FactoriesMaterializeFactoryAppTemplateData, ThrowOnError>,
): RequestResult<
  FactoriesMaterializeFactoryAppTemplateResponses,
  FactoriesMaterializeFactoryAppTemplateErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    FactoriesMaterializeFactoryAppTemplateResponses,
    FactoriesMaterializeFactoryAppTemplateErrors,
    ThrowOnError
  >({
    url: "/api/v1/factories/{factoryId}/app-templates/{templateId}:materialize",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * List factory automations
 *
 * Returns canvases owned by a factory
 */
export const factoriesListFactoryAutomations = <ThrowOnError extends boolean = true>(
  options: Options<FactoriesListFactoryAutomationsData, ThrowOnError>,
): RequestResult<FactoriesListFactoryAutomationsResponses, FactoriesListFactoryAutomationsErrors, ThrowOnError> =>
  (options.client ?? client).get<
    FactoriesListFactoryAutomationsResponses,
    FactoriesListFactoryAutomationsErrors,
    ThrowOnError
  >({ url: "/api/v1/factories/{factoryId}/automations", ...options });

/**
 * Create factory automation
 *
 * Creates a blank factory canvas and optionally attaches it to Verify or Done
 */
export const factoriesCreateFactoryAutomation = <ThrowOnError extends boolean = true>(
  options: Options<FactoriesCreateFactoryAutomationData, ThrowOnError>,
): RequestResult<FactoriesCreateFactoryAutomationResponses, FactoriesCreateFactoryAutomationErrors, ThrowOnError> =>
  (options.client ?? client).post<
    FactoriesCreateFactoryAutomationResponses,
    FactoriesCreateFactoryAutomationErrors,
    ThrowOnError
  >({
    url: "/api/v1/factories/{factoryId}/automations",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Delete factory automation
 *
 * Deletes a factory canvas
 */
export const factoriesDeleteFactoryAutomation = <ThrowOnError extends boolean = true>(
  options: Options<FactoriesDeleteFactoryAutomationData, ThrowOnError>,
): RequestResult<FactoriesDeleteFactoryAutomationResponses, FactoriesDeleteFactoryAutomationErrors, ThrowOnError> =>
  (options.client ?? client).delete<
    FactoriesDeleteFactoryAutomationResponses,
    FactoriesDeleteFactoryAutomationErrors,
    ThrowOnError
  >({ url: "/api/v1/factories/{factoryId}/automations/{automationId}", ...options });

/**
 * Materialize factory automation defaults
 *
 * Builds the bundled defaults for an installed factory automation and preserves its connections
 */
export const factoriesMaterializeFactoryAutomationDefaults = <ThrowOnError extends boolean = true>(
  options: Options<FactoriesMaterializeFactoryAutomationDefaultsData, ThrowOnError>,
): RequestResult<
  FactoriesMaterializeFactoryAutomationDefaultsResponses,
  FactoriesMaterializeFactoryAutomationDefaultsErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    FactoriesMaterializeFactoryAutomationDefaultsResponses,
    FactoriesMaterializeFactoryAutomationDefaultsErrors,
    ThrowOnError
  >({
    url: "/api/v1/factories/{factoryId}/automations/{automationId}:defaults",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Refresh the backlog
 *
 * Archives backlog work orders whose intake items are closed or no longer available
 */
export const factoriesRefreshBacklog = <ThrowOnError extends boolean = true>(
  options: Options<FactoriesRefreshBacklogData, ThrowOnError>,
): RequestResult<FactoriesRefreshBacklogResponses, FactoriesRefreshBacklogErrors, ThrowOnError> =>
  (options.client ?? client).post<FactoriesRefreshBacklogResponses, FactoriesRefreshBacklogErrors, ThrowOnError>({
    url: "/api/v1/factories/{factoryId}/backlog/refresh",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Preview Dependabot packages for intake setup
 *
 * Lists open alert packages before the Dependabot intake exists
 */
export const factoriesSearchDependabotIntakeSetupItems = <ThrowOnError extends boolean = true>(
  options: Options<FactoriesSearchDependabotIntakeSetupItemsData, ThrowOnError>,
): RequestResult<
  FactoriesSearchDependabotIntakeSetupItemsResponses,
  FactoriesSearchDependabotIntakeSetupItemsErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    FactoriesSearchDependabotIntakeSetupItemsResponses,
    FactoriesSearchDependabotIntakeSetupItemsErrors,
    ThrowOnError
  >({ url: "/api/v1/factories/{factoryId}/dependabot-intake-setup-items", ...options });

/**
 * List workspace files
 *
 * Returns ready files scoped to a workspace
 */
export const filesListFactoryFiles = <ThrowOnError extends boolean = true>(
  options: Options<FilesListFactoryFilesData, ThrowOnError>,
): RequestResult<FilesListFactoryFilesResponses, FilesListFactoryFilesErrors, ThrowOnError> =>
  (options.client ?? client).get<FilesListFactoryFilesResponses, FilesListFactoryFilesErrors, ThrowOnError>({
    url: "/api/v1/factories/{factoryId}/files",
    ...options,
  });

/**
 * Create a workspace file
 *
 * Creates a pending workspace-scoped file. Upload bytes with PUT /api/v1/files/{file_id}/content.
 */
export const filesCreateFactoryFile = <ThrowOnError extends boolean = true>(
  options: Options<FilesCreateFactoryFileData, ThrowOnError>,
): RequestResult<FilesCreateFactoryFileResponses, FilesCreateFactoryFileErrors, ThrowOnError> =>
  (options.client ?? client).post<FilesCreateFactoryFileResponses, FilesCreateFactoryFileErrors, ThrowOnError>({
    url: "/api/v1/factories/{factoryId}/files",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * List factory intakes
 *
 * Returns the intakes of a factory
 */
export const factoriesListFactoryIntakes = <ThrowOnError extends boolean = true>(
  options: Options<FactoriesListFactoryIntakesData, ThrowOnError>,
): RequestResult<FactoriesListFactoryIntakesResponses, FactoriesListFactoryIntakesErrors, ThrowOnError> =>
  (options.client ?? client).get<FactoriesListFactoryIntakesResponses, FactoriesListFactoryIntakesErrors, ThrowOnError>(
    { url: "/api/v1/factories/{factoryId}/intakes", ...options },
  );

/**
 * Create factory intake
 *
 * Creates an intake and the canvas that runs it
 */
export const factoriesCreateFactoryIntake = <ThrowOnError extends boolean = true>(
  options: Options<FactoriesCreateFactoryIntakeData, ThrowOnError>,
): RequestResult<FactoriesCreateFactoryIntakeResponses, FactoriesCreateFactoryIntakeErrors, ThrowOnError> =>
  (options.client ?? client).post<
    FactoriesCreateFactoryIntakeResponses,
    FactoriesCreateFactoryIntakeErrors,
    ThrowOnError
  >({
    url: "/api/v1/factories/{factoryId}/intakes",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Delete factory intake
 *
 * Deletes an intake and its canvas
 */
export const factoriesDeleteFactoryIntake = <ThrowOnError extends boolean = true>(
  options: Options<FactoriesDeleteFactoryIntakeData, ThrowOnError>,
): RequestResult<FactoriesDeleteFactoryIntakeResponses, FactoriesDeleteFactoryIntakeErrors, ThrowOnError> =>
  (options.client ?? client).delete<
    FactoriesDeleteFactoryIntakeResponses,
    FactoriesDeleteFactoryIntakeErrors,
    ThrowOnError
  >({ url: "/api/v1/factories/{factoryId}/intakes/{intakeId}", ...options });

/**
 * Update factory intake
 *
 * Updates the name and settings of an intake
 */
export const factoriesUpdateFactoryIntake = <ThrowOnError extends boolean = true>(
  options: Options<FactoriesUpdateFactoryIntakeData, ThrowOnError>,
): RequestResult<FactoriesUpdateFactoryIntakeResponses, FactoriesUpdateFactoryIntakeErrors, ThrowOnError> =>
  (options.client ?? client).patch<
    FactoriesUpdateFactoryIntakeResponses,
    FactoriesUpdateFactoryIntakeErrors,
    ThrowOnError
  >({
    url: "/api/v1/factories/{factoryId}/intakes/{intakeId}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Import factory intake item
 *
 * Creates a backlog work order from an intake item
 */
export const factoriesImportFactoryIntakeItem = <ThrowOnError extends boolean = true>(
  options: Options<FactoriesImportFactoryIntakeItemData, ThrowOnError>,
): RequestResult<FactoriesImportFactoryIntakeItemResponses, FactoriesImportFactoryIntakeItemErrors, ThrowOnError> =>
  (options.client ?? client).post<
    FactoriesImportFactoryIntakeItemResponses,
    FactoriesImportFactoryIntakeItemErrors,
    ThrowOnError
  >({
    url: "/api/v1/factories/{factoryId}/intakes/{intakeId}/imports",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Search factory intake items
 *
 * Returns recent or matching items from the intake source
 */
export const factoriesSearchFactoryIntakeItems = <ThrowOnError extends boolean = true>(
  options: Options<FactoriesSearchFactoryIntakeItemsData, ThrowOnError>,
): RequestResult<FactoriesSearchFactoryIntakeItemsResponses, FactoriesSearchFactoryIntakeItemsErrors, ThrowOnError> =>
  (options.client ?? client).get<
    FactoriesSearchFactoryIntakeItemsResponses,
    FactoriesSearchFactoryIntakeItemsErrors,
    ThrowOnError
  >({ url: "/api/v1/factories/{factoryId}/intakes/{intakeId}/items", ...options });

/**
 * List factory intake runs
 *
 * Returns what an intake received, how it scored, and where it went
 */
export const factoriesListFactoryIntakeRuns = <ThrowOnError extends boolean = true>(
  options: Options<FactoriesListFactoryIntakeRunsData, ThrowOnError>,
): RequestResult<FactoriesListFactoryIntakeRunsResponses, FactoriesListFactoryIntakeRunsErrors, ThrowOnError> =>
  (options.client ?? client).get<
    FactoriesListFactoryIntakeRunsResponses,
    FactoriesListFactoryIntakeRunsErrors,
    ThrowOnError
  >({ url: "/api/v1/factories/{factoryId}/intakes/{intakeId}/runs", ...options });

/**
 * List line runner models
 *
 * Returns the models a draft task can pick for the runner agents on one factory line
 */
export const factoriesListFactoryLineRunnerModels = <ThrowOnError extends boolean = true>(
  options: Options<FactoriesListFactoryLineRunnerModelsData, ThrowOnError>,
): RequestResult<
  FactoriesListFactoryLineRunnerModelsResponses,
  FactoriesListFactoryLineRunnerModelsErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    FactoriesListFactoryLineRunnerModelsResponses,
    FactoriesListFactoryLineRunnerModelsErrors,
    ThrowOnError
  >({ url: "/api/v1/factories/{factoryId}/line-runner-models", ...options });

/**
 * Create factory line
 *
 * Creates a new line for a factory
 */
export const factoriesCreateFactoryLine = <ThrowOnError extends boolean = true>(
  options: Options<FactoriesCreateFactoryLineData, ThrowOnError>,
): RequestResult<FactoriesCreateFactoryLineResponses, FactoriesCreateFactoryLineErrors, ThrowOnError> =>
  (options.client ?? client).post<FactoriesCreateFactoryLineResponses, FactoriesCreateFactoryLineErrors, ThrowOnError>({
    url: "/api/v1/factories/{factoryId}/lines",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Update factory line
 *
 * Updates a factory line
 */
export const factoriesUpdateFactoryLine = <ThrowOnError extends boolean = true>(
  options: Options<FactoriesUpdateFactoryLineData, ThrowOnError>,
): RequestResult<FactoriesUpdateFactoryLineResponses, FactoriesUpdateFactoryLineErrors, ThrowOnError> =>
  (options.client ?? client).patch<FactoriesUpdateFactoryLineResponses, FactoriesUpdateFactoryLineErrors, ThrowOnError>(
    {
      url: "/api/v1/factories/{factoryId}/lines/{lineId}",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    },
  );

/**
 * List factory LLM models
 *
 * Returns the parent model list and the workspace subset for one provider
 */
export const factoriesListFactoryLlmModels = <ThrowOnError extends boolean = true>(
  options: Options<FactoriesListFactoryLlmModelsData, ThrowOnError>,
): RequestResult<FactoriesListFactoryLlmModelsResponses, FactoriesListFactoryLlmModelsErrors, ThrowOnError> =>
  (options.client ?? client).get<
    FactoriesListFactoryLlmModelsResponses,
    FactoriesListFactoryLlmModelsErrors,
    ThrowOnError
  >({ url: "/api/v1/factories/{factoryId}/llm-models", ...options });

/**
 * Update factory LLM models
 *
 * Sets the workspace subset of parent models. An empty list inherits the parent list.
 */
export const factoriesUpdateFactoryLlmModels = <ThrowOnError extends boolean = true>(
  options: Options<FactoriesUpdateFactoryLlmModelsData, ThrowOnError>,
): RequestResult<FactoriesUpdateFactoryLlmModelsResponses, FactoriesUpdateFactoryLlmModelsErrors, ThrowOnError> =>
  (options.client ?? client).put<
    FactoriesUpdateFactoryLlmModelsResponses,
    FactoriesUpdateFactoryLlmModelsErrors,
    ThrowOnError
  >({
    url: "/api/v1/factories/{factoryId}/llm-models",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * List SuperPlane MCP clients
 *
 * Returns MCP clients that signed in to this workspace.
 */
export const factoriesListFactoryMcpClients = <ThrowOnError extends boolean = true>(
  options: Options<FactoriesListFactoryMcpClientsData, ThrowOnError>,
): RequestResult<FactoriesListFactoryMcpClientsResponses, FactoriesListFactoryMcpClientsErrors, ThrowOnError> =>
  (options.client ?? client).get<
    FactoriesListFactoryMcpClientsResponses,
    FactoriesListFactoryMcpClientsErrors,
    ThrowOnError
  >({ url: "/api/v1/factories/{factoryId}/mcp-clients", ...options });

/**
 * Revoke a SuperPlane MCP client
 *
 * Disconnects an MCP client from this workspace. The client must sign in again.
 */
export const factoriesRevokeFactoryMcpClient = <ThrowOnError extends boolean = true>(
  options: Options<FactoriesRevokeFactoryMcpClientData, ThrowOnError>,
): RequestResult<FactoriesRevokeFactoryMcpClientResponses, FactoriesRevokeFactoryMcpClientErrors, ThrowOnError> =>
  (options.client ?? client).delete<
    FactoriesRevokeFactoryMcpClientResponses,
    FactoriesRevokeFactoryMcpClientErrors,
    ThrowOnError
  >({ url: "/api/v1/factories/{factoryId}/mcp-clients/{clientId}", ...options });

/**
 * List factory work orders
 *
 * Returns one page of work orders for a factory. The default page size is 100. Pass before_id to return orders older than that id.
 */
export const factoriesListWorkOrders = <ThrowOnError extends boolean = true>(
  options: Options<FactoriesListWorkOrdersData, ThrowOnError>,
): RequestResult<FactoriesListWorkOrdersResponses, FactoriesListWorkOrdersErrors, ThrowOnError> =>
  (options.client ?? client).get<FactoriesListWorkOrdersResponses, FactoriesListWorkOrdersErrors, ThrowOnError>({
    url: "/api/v1/factories/{factoryId}/orders",
    ...options,
  });

/**
 * Create factory work order
 *
 * Creates a new work order for a factory
 */
export const factoriesCreateWorkOrder = <ThrowOnError extends boolean = true>(
  options: Options<FactoriesCreateWorkOrderData, ThrowOnError>,
): RequestResult<FactoriesCreateWorkOrderResponses, FactoriesCreateWorkOrderErrors, ThrowOnError> =>
  (options.client ?? client).post<FactoriesCreateWorkOrderResponses, FactoriesCreateWorkOrderErrors, ThrowOnError>({
    url: "/api/v1/factories/{factoryId}/orders",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Describe factory work order
 *
 * Returns a work order by ID, number, or key
 */
export const factoriesDescribeWorkOrder = <ThrowOnError extends boolean = true>(
  options: Options<FactoriesDescribeWorkOrderData, ThrowOnError>,
): RequestResult<FactoriesDescribeWorkOrderResponses, FactoriesDescribeWorkOrderErrors, ThrowOnError> =>
  (options.client ?? client).get<FactoriesDescribeWorkOrderResponses, FactoriesDescribeWorkOrderErrors, ThrowOnError>({
    url: "/api/v1/factories/{factoryId}/orders/{orderId}",
    ...options,
  });

/**
 * Update factory work order
 *
 * Updates the title and description of a work order
 */
export const factoriesUpdateWorkOrder = <ThrowOnError extends boolean = true>(
  options: Options<FactoriesUpdateWorkOrderData, ThrowOnError>,
): RequestResult<FactoriesUpdateWorkOrderResponses, FactoriesUpdateWorkOrderErrors, ThrowOnError> =>
  (options.client ?? client).patch<FactoriesUpdateWorkOrderResponses, FactoriesUpdateWorkOrderErrors, ThrowOnError>({
    url: "/api/v1/factories/{factoryId}/orders/{orderId}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * List work order artifacts
 *
 * Returns artifacts attached to a work order
 */
export const factoriesListWorkOrderArtifacts = <ThrowOnError extends boolean = true>(
  options: Options<FactoriesListWorkOrderArtifactsData, ThrowOnError>,
): RequestResult<FactoriesListWorkOrderArtifactsResponses, FactoriesListWorkOrderArtifactsErrors, ThrowOnError> =>
  (options.client ?? client).get<
    FactoriesListWorkOrderArtifactsResponses,
    FactoriesListWorkOrderArtifactsErrors,
    ThrowOnError
  >({ url: "/api/v1/factories/{factoryId}/orders/{orderId}/artifacts", ...options });

/**
 * Create work order artifact
 *
 * Attaches a typed artifact to a work order
 */
export const factoriesCreateWorkOrderArtifact = <ThrowOnError extends boolean = true>(
  options: Options<FactoriesCreateWorkOrderArtifactData, ThrowOnError>,
): RequestResult<FactoriesCreateWorkOrderArtifactResponses, FactoriesCreateWorkOrderArtifactErrors, ThrowOnError> =>
  (options.client ?? client).post<
    FactoriesCreateWorkOrderArtifactResponses,
    FactoriesCreateWorkOrderArtifactErrors,
    ThrowOnError
  >({
    url: "/api/v1/factories/{factoryId}/orders/{orderId}/artifacts",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Update a work order's assignees
 *
 * Updates the assignees of a work order
 */
export const factoriesUpdateWorkOrderAssignees = <ThrowOnError extends boolean = true>(
  options: Options<FactoriesUpdateWorkOrderAssigneesData, ThrowOnError>,
): RequestResult<FactoriesUpdateWorkOrderAssigneesResponses, FactoriesUpdateWorkOrderAssigneesErrors, ThrowOnError> =>
  (options.client ?? client).patch<
    FactoriesUpdateWorkOrderAssigneesResponses,
    FactoriesUpdateWorkOrderAssigneesErrors,
    ThrowOnError
  >({
    url: "/api/v1/factories/{factoryId}/orders/{orderId}/assignees",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Send work order to backlog
 *
 * Moves a closed work order to draft and optionally closes pull requests and clears artifacts
 */
export const factoriesSendWorkOrderToBacklog = <ThrowOnError extends boolean = true>(
  options: Options<FactoriesSendWorkOrderToBacklogData, ThrowOnError>,
): RequestResult<FactoriesSendWorkOrderToBacklogResponses, FactoriesSendWorkOrderToBacklogErrors, ThrowOnError> =>
  (options.client ?? client).patch<
    FactoriesSendWorkOrderToBacklogResponses,
    FactoriesSendWorkOrderToBacklogErrors,
    ThrowOnError
  >({
    url: "/api/v1/factories/{factoryId}/orders/{orderId}/backlog",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Close factory work order
 *
 * Closes a work order
 */
export const factoriesCloseWorkOrder = <ThrowOnError extends boolean = true>(
  options: Options<FactoriesCloseWorkOrderData, ThrowOnError>,
): RequestResult<FactoriesCloseWorkOrderResponses, FactoriesCloseWorkOrderErrors, ThrowOnError> =>
  (options.client ?? client).patch<FactoriesCloseWorkOrderResponses, FactoriesCloseWorkOrderErrors, ThrowOnError>({
    url: "/api/v1/factories/{factoryId}/orders/{orderId}/close",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Add work order comment
 *
 * Appends a comment to the work order timeline
 */
export const factoriesAddWorkOrderComment = <ThrowOnError extends boolean = true>(
  options: Options<FactoriesAddWorkOrderCommentData, ThrowOnError>,
): RequestResult<FactoriesAddWorkOrderCommentResponses, FactoriesAddWorkOrderCommentErrors, ThrowOnError> =>
  (options.client ?? client).post<
    FactoriesAddWorkOrderCommentResponses,
    FactoriesAddWorkOrderCommentErrors,
    ThrowOnError
  >({
    url: "/api/v1/factories/{factoryId}/orders/{orderId}/comments",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Dispatch a work order
 *
 * Dispatches a work order to a factory line
 */
export const factoriesDispatchWorkOrder = <ThrowOnError extends boolean = true>(
  options: Options<FactoriesDispatchWorkOrderData, ThrowOnError>,
): RequestResult<FactoriesDispatchWorkOrderResponses, FactoriesDispatchWorkOrderErrors, ThrowOnError> =>
  (options.client ?? client).patch<FactoriesDispatchWorkOrderResponses, FactoriesDispatchWorkOrderErrors, ThrowOnError>(
    {
      url: "/api/v1/factories/{factoryId}/orders/{orderId}/dispatch",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    },
  );

/**
 * List factory work order events
 *
 * Returns a list of events for a work order
 */
export const factoriesListWorkOrderEvents = <ThrowOnError extends boolean = true>(
  options: Options<FactoriesListWorkOrderEventsData, ThrowOnError>,
): RequestResult<FactoriesListWorkOrderEventsResponses, FactoriesListWorkOrderEventsErrors, ThrowOnError> =>
  (options.client ?? client).get<
    FactoriesListWorkOrderEventsResponses,
    FactoriesListWorkOrderEventsErrors,
    ThrowOnError
  >({ url: "/api/v1/factories/{factoryId}/orders/{orderId}/events", ...options });

/**
 * List task files
 *
 * Returns ready files scoped to a task
 */
export const filesListWorkOrderFiles = <ThrowOnError extends boolean = true>(
  options: Options<FilesListWorkOrderFilesData, ThrowOnError>,
): RequestResult<FilesListWorkOrderFilesResponses, FilesListWorkOrderFilesErrors, ThrowOnError> =>
  (options.client ?? client).get<FilesListWorkOrderFilesResponses, FilesListWorkOrderFilesErrors, ThrowOnError>({
    url: "/api/v1/factories/{factoryId}/orders/{orderId}/files",
    ...options,
  });

/**
 * Create a task file
 *
 * Creates a pending task-scoped file. Upload bytes with PUT /api/v1/files/{file_id}/content.
 */
export const filesCreateWorkOrderFile = <ThrowOnError extends boolean = true>(
  options: Options<FilesCreateWorkOrderFileData, ThrowOnError>,
): RequestResult<FilesCreateWorkOrderFileResponses, FilesCreateWorkOrderFileErrors, ThrowOnError> =>
  (options.client ?? client).post<FilesCreateWorkOrderFileResponses, FilesCreateWorkOrderFileErrors, ThrowOnError>({
    url: "/api/v1/factories/{factoryId}/orders/{orderId}/files",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Update work order status
 *
 * Transitions a work order between lifecycle states
 */
export const factoriesUpdateWorkOrderStatus = <ThrowOnError extends boolean = true>(
  options: Options<FactoriesUpdateWorkOrderStatusData, ThrowOnError>,
): RequestResult<FactoriesUpdateWorkOrderStatusResponses, FactoriesUpdateWorkOrderStatusErrors, ThrowOnError> =>
  (options.client ?? client).patch<
    FactoriesUpdateWorkOrderStatusResponses,
    FactoriesUpdateWorkOrderStatusErrors,
    ThrowOnError
  >({
    url: "/api/v1/factories/{factoryId}/orders/{orderId}/status",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Describe planning session
 *
 * Returns a planning session
 */
export const factoriesDescribePlanningSession = <ThrowOnError extends boolean = true>(
  options: Options<FactoriesDescribePlanningSessionData, ThrowOnError>,
): RequestResult<FactoriesDescribePlanningSessionResponses, FactoriesDescribePlanningSessionErrors, ThrowOnError> =>
  (options.client ?? client).get<
    FactoriesDescribePlanningSessionResponses,
    FactoriesDescribePlanningSessionErrors,
    ThrowOnError
  >({ url: "/api/v1/factories/{factoryId}/planning-sessions/{sessionId}", ...options });

/**
 * End planning session
 *
 * Stops the planning session machine
 */
export const factoriesEndPlanningSession = <ThrowOnError extends boolean = true>(
  options: Options<FactoriesEndPlanningSessionData, ThrowOnError>,
): RequestResult<FactoriesEndPlanningSessionResponses, FactoriesEndPlanningSessionErrors, ThrowOnError> =>
  (options.client ?? client).post<
    FactoriesEndPlanningSessionResponses,
    FactoriesEndPlanningSessionErrors,
    ThrowOnError
  >({
    url: "/api/v1/factories/{factoryId}/planning-sessions/{sessionId}/end",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Send planning session message
 *
 * Sends a user message in a planning session
 */
export const factoriesSendPlanningSessionMessage = <ThrowOnError extends boolean = true>(
  options: Options<FactoriesSendPlanningSessionMessageData, ThrowOnError>,
): RequestResult<
  FactoriesSendPlanningSessionMessageResponses,
  FactoriesSendPlanningSessionMessageErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    FactoriesSendPlanningSessionMessageResponses,
    FactoriesSendPlanningSessionMessageErrors,
    ThrowOnError
  >({
    url: "/api/v1/factories/{factoryId}/planning-sessions/{sessionId}/messages",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Answer planning session survey
 *
 * Sends the user's survey answer to an analysis planning session
 */
export const factoriesAnswerPlanningSessionSurvey = <ThrowOnError extends boolean = true>(
  options: Options<FactoriesAnswerPlanningSessionSurveyData, ThrowOnError>,
): RequestResult<
  FactoriesAnswerPlanningSessionSurveyResponses,
  FactoriesAnswerPlanningSessionSurveyErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    FactoriesAnswerPlanningSessionSurveyResponses,
    FactoriesAnswerPlanningSessionSurveyErrors,
    ThrowOnError
  >({
    url: "/api/v1/factories/{factoryId}/planning-sessions/{sessionId}/survey-answer",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * List factory PR feedback handlers
 *
 * Returns the PR feedback handlers of a factory
 */
export const factoriesListFactoryPrFeedbackHandlers = <ThrowOnError extends boolean = true>(
  options: Options<FactoriesListFactoryPrFeedbackHandlersData, ThrowOnError>,
): RequestResult<
  FactoriesListFactoryPrFeedbackHandlersResponses,
  FactoriesListFactoryPrFeedbackHandlersErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    FactoriesListFactoryPrFeedbackHandlersResponses,
    FactoriesListFactoryPrFeedbackHandlersErrors,
    ThrowOnError
  >({ url: "/api/v1/factories/{factoryId}/pr-feedback-handlers", ...options });

/**
 * Create factory PR feedback handler
 *
 * Creates a PR feedback handler and the canvas that runs it
 */
export const factoriesCreateFactoryPrFeedbackHandler = <ThrowOnError extends boolean = true>(
  options: Options<FactoriesCreateFactoryPrFeedbackHandlerData, ThrowOnError>,
): RequestResult<
  FactoriesCreateFactoryPrFeedbackHandlerResponses,
  FactoriesCreateFactoryPrFeedbackHandlerErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    FactoriesCreateFactoryPrFeedbackHandlerResponses,
    FactoriesCreateFactoryPrFeedbackHandlerErrors,
    ThrowOnError
  >({
    url: "/api/v1/factories/{factoryId}/pr-feedback-handlers",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Delete factory PR feedback handler
 *
 * Deletes a PR feedback handler and its canvas
 */
export const factoriesDeleteFactoryPrFeedbackHandler = <ThrowOnError extends boolean = true>(
  options: Options<FactoriesDeleteFactoryPrFeedbackHandlerData, ThrowOnError>,
): RequestResult<
  FactoriesDeleteFactoryPrFeedbackHandlerResponses,
  FactoriesDeleteFactoryPrFeedbackHandlerErrors,
  ThrowOnError
> =>
  (options.client ?? client).delete<
    FactoriesDeleteFactoryPrFeedbackHandlerResponses,
    FactoriesDeleteFactoryPrFeedbackHandlerErrors,
    ThrowOnError
  >({ url: "/api/v1/factories/{factoryId}/pr-feedback-handlers/{handlerId}", ...options });

/**
 * Update factory PR feedback handler
 *
 * Updates the name and settings of a PR feedback handler
 */
export const factoriesUpdateFactoryPrFeedbackHandler = <ThrowOnError extends boolean = true>(
  options: Options<FactoriesUpdateFactoryPrFeedbackHandlerData, ThrowOnError>,
): RequestResult<
  FactoriesUpdateFactoryPrFeedbackHandlerResponses,
  FactoriesUpdateFactoryPrFeedbackHandlerErrors,
  ThrowOnError
> =>
  (options.client ?? client).patch<
    FactoriesUpdateFactoryPrFeedbackHandlerResponses,
    FactoriesUpdateFactoryPrFeedbackHandlerErrors,
    ThrowOnError
  >({
    url: "/api/v1/factories/{factoryId}/pr-feedback-handlers/{handlerId}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Create factory pull request
 *
 * Tracks a pull request on a work order
 */
export const factoriesCreateFactoryPullRequest = <ThrowOnError extends boolean = true>(
  options: Options<FactoriesCreateFactoryPullRequestData, ThrowOnError>,
): RequestResult<FactoriesCreateFactoryPullRequestResponses, FactoriesCreateFactoryPullRequestErrors, ThrowOnError> =>
  (options.client ?? client).post<
    FactoriesCreateFactoryPullRequestResponses,
    FactoriesCreateFactoryPullRequestErrors,
    ThrowOnError
  >({
    url: "/api/v1/factories/{factoryId}/prs",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Describe factory pull request
 *
 * Returns a factory pull request by its ID
 */
export const factoriesDescribeFactoryPullRequest = <ThrowOnError extends boolean = true>(
  options: Options<FactoriesDescribeFactoryPullRequestData, ThrowOnError>,
): RequestResult<
  FactoriesDescribeFactoryPullRequestResponses,
  FactoriesDescribeFactoryPullRequestErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    FactoriesDescribeFactoryPullRequestResponses,
    FactoriesDescribeFactoryPullRequestErrors,
    ThrowOnError
  >({ url: "/api/v1/factories/{factoryId}/prs/{prId}", ...options });

/**
 * Update factory pull request
 *
 * Updates a tracked factory pull request
 */
export const factoriesUpdateFactoryPullRequest = <ThrowOnError extends boolean = true>(
  options: Options<FactoriesUpdateFactoryPullRequestData, ThrowOnError>,
): RequestResult<FactoriesUpdateFactoryPullRequestResponses, FactoriesUpdateFactoryPullRequestErrors, ThrowOnError> =>
  (options.client ?? client).patch<
    FactoriesUpdateFactoryPullRequestResponses,
    FactoriesUpdateFactoryPullRequestErrors,
    ThrowOnError
  >({
    url: "/api/v1/factories/{factoryId}/prs/{prId}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Merge factory pull request
 *
 * Merges a tracked GitHub pull request with a method the repository allows
 */
export const factoriesMergeFactoryPullRequest = <ThrowOnError extends boolean = true>(
  options: Options<FactoriesMergeFactoryPullRequestData, ThrowOnError>,
): RequestResult<FactoriesMergeFactoryPullRequestResponses, FactoriesMergeFactoryPullRequestErrors, ThrowOnError> =>
  (options.client ?? client).post<
    FactoriesMergeFactoryPullRequestResponses,
    FactoriesMergeFactoryPullRequestErrors,
    ThrowOnError
  >({
    url: "/api/v1/factories/{factoryId}/prs/{prId}/merge",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Describe factory pull request mergeability
 *
 * Returns whether a tracked factory pull request can merge from SuperPlane
 */
export const factoriesDescribeFactoryPullRequestMergeability = <ThrowOnError extends boolean = true>(
  options: Options<FactoriesDescribeFactoryPullRequestMergeabilityData, ThrowOnError>,
): RequestResult<
  FactoriesDescribeFactoryPullRequestMergeabilityResponses,
  FactoriesDescribeFactoryPullRequestMergeabilityErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    FactoriesDescribeFactoryPullRequestMergeabilityResponses,
    FactoriesDescribeFactoryPullRequestMergeabilityErrors,
    ThrowOnError
  >({ url: "/api/v1/factories/{factoryId}/prs/{prId}/mergeability", ...options });

/**
 * Describe factory LLM spend
 *
 * Returns token and estimated dollar spend for a workspace, grouped by model
 */
export const factoriesDescribeFactoryUsage = <ThrowOnError extends boolean = true>(
  options: Options<FactoriesDescribeFactoryUsageData, ThrowOnError>,
): RequestResult<FactoriesDescribeFactoryUsageResponses, FactoriesDescribeFactoryUsageErrors, ThrowOnError> =>
  (options.client ?? client).get<
    FactoriesDescribeFactoryUsageResponses,
    FactoriesDescribeFactoryUsageErrors,
    ThrowOnError
  >({ url: "/api/v1/factories/{factoryId}/usage", ...options });

/**
 * List factory work-order run usage
 *
 * Returns paginated task-run spend for a workspace from the usage ledger
 */
export const factoriesListFactoryWorkOrderRunUsage = <ThrowOnError extends boolean = true>(
  options: Options<FactoriesListFactoryWorkOrderRunUsageData, ThrowOnError>,
): RequestResult<
  FactoriesListFactoryWorkOrderRunUsageResponses,
  FactoriesListFactoryWorkOrderRunUsageErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    FactoriesListFactoryWorkOrderRunUsageResponses,
    FactoriesListFactoryWorkOrderRunUsageErrors,
    ThrowOnError
  >({ url: "/api/v1/factories/{factoryId}/usage-history", ...options });

/**
 * Export factory work-order run usage
 *
 * Returns the full task-run spend ledger for a workspace as CSV, with no date window
 */
export const factoriesExportFactoryWorkOrderRunUsage = <ThrowOnError extends boolean = true>(
  options: Options<FactoriesExportFactoryWorkOrderRunUsageData, ThrowOnError>,
): RequestResult<
  FactoriesExportFactoryWorkOrderRunUsageResponses,
  FactoriesExportFactoryWorkOrderRunUsageErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    FactoriesExportFactoryWorkOrderRunUsageResponses,
    FactoriesExportFactoryWorkOrderRunUsageErrors,
    ThrowOnError
  >({ url: "/api/v1/factories/{factoryId}/usage-history.csv", ...options });

/**
 * Describe factory velocity
 *
 * Returns SuperPlane vs People merge counts and waste for a factory over a period
 */
export const factoriesDescribeFactoryVelocity = <ThrowOnError extends boolean = true>(
  options: Options<FactoriesDescribeFactoryVelocityData, ThrowOnError>,
): RequestResult<FactoriesDescribeFactoryVelocityResponses, FactoriesDescribeFactoryVelocityErrors, ThrowOnError> =>
  (options.client ?? client).get<
    FactoriesDescribeFactoryVelocityResponses,
    FactoriesDescribeFactoryVelocityErrors,
    ThrowOnError
  >({ url: "/api/v1/factories/{factoryId}/velocity", ...options });

/**
 * Sync factory velocity
 *
 * Starts a repository merge sync for a factory and returns before it finishes
 */
export const factoriesSyncFactoryVelocity = <ThrowOnError extends boolean = true>(
  options: Options<FactoriesSyncFactoryVelocityData, ThrowOnError>,
): RequestResult<FactoriesSyncFactoryVelocityResponses, FactoriesSyncFactoryVelocityErrors, ThrowOnError> =>
  (options.client ?? client).post<
    FactoriesSyncFactoryVelocityResponses,
    FactoriesSyncFactoryVelocityErrors,
    ThrowOnError
  >({
    url: "/api/v1/factories/{factoryId}/velocity/sync",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Find planning session by work order
 *
 * Returns the analysis planning session for a draft work order
 */
export const factoriesFindPlanningSessionByWorkOrder = <ThrowOnError extends boolean = true>(
  options: Options<FactoriesFindPlanningSessionByWorkOrderData, ThrowOnError>,
): RequestResult<
  FactoriesFindPlanningSessionByWorkOrderResponses,
  FactoriesFindPlanningSessionByWorkOrderErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    FactoriesFindPlanningSessionByWorkOrderResponses,
    FactoriesFindPlanningSessionByWorkOrderErrors,
    ThrowOnError
  >({ url: "/api/v1/factories/{factoryId}/work-orders/{workOrderId}/planning-session", ...options });

/**
 * Delete factory
 *
 * Soft-deletes an existing factory
 */
export const factoriesDeleteFactory = <ThrowOnError extends boolean = true>(
  options: Options<FactoriesDeleteFactoryData, ThrowOnError>,
): RequestResult<FactoriesDeleteFactoryResponses, FactoriesDeleteFactoryErrors, ThrowOnError> =>
  (options.client ?? client).delete<FactoriesDeleteFactoryResponses, FactoriesDeleteFactoryErrors, ThrowOnError>({
    url: "/api/v1/factories/{id}",
    ...options,
  });

/**
 * Describe factory
 *
 * Returns a factory by ID or workspace key. Workspace names are not accepted: they are not unique and can contain spaces.
 */
export const factoriesDescribeFactory = <ThrowOnError extends boolean = true>(
  options: Options<FactoriesDescribeFactoryData, ThrowOnError>,
): RequestResult<FactoriesDescribeFactoryResponses, FactoriesDescribeFactoryErrors, ThrowOnError> =>
  (options.client ?? client).get<FactoriesDescribeFactoryResponses, FactoriesDescribeFactoryErrors, ThrowOnError>({
    url: "/api/v1/factories/{id}",
    ...options,
  });

/**
 * Update factory
 *
 * Updates factory metadata
 */
export const factoriesUpdateFactory = <ThrowOnError extends boolean = true>(
  options: Options<FactoriesUpdateFactoryData, ThrowOnError>,
): RequestResult<FactoriesUpdateFactoryResponses, FactoriesUpdateFactoryErrors, ThrowOnError> =>
  (options.client ?? client).put<FactoriesUpdateFactoryResponses, FactoriesUpdateFactoryErrors, ThrowOnError>({
    url: "/api/v1/factories/{id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Switch factory model source
 *
 * Saves a provider key, updates the workspace agent harness, and rewrites agent nodes on workspace canvases
 */
export const factoriesSwitchFactoryModelSource = <ThrowOnError extends boolean = true>(
  options: Options<FactoriesSwitchFactoryModelSourceData, ThrowOnError>,
): RequestResult<FactoriesSwitchFactoryModelSourceResponses, FactoriesSwitchFactoryModelSourceErrors, ThrowOnError> =>
  (options.client ?? client).post<
    FactoriesSwitchFactoryModelSourceResponses,
    FactoriesSwitchFactoryModelSourceErrors,
    ThrowOnError
  >({
    url: "/api/v1/factories/{id}/model-source",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Update factory onboarding
 *
 * Saves workspace onboarding progress and optionally marks setup complete
 */
export const factoriesUpdateFactoryOnboarding = <ThrowOnError extends boolean = true>(
  options: Options<FactoriesUpdateFactoryOnboardingData, ThrowOnError>,
): RequestResult<FactoriesUpdateFactoryOnboardingResponses, FactoriesUpdateFactoryOnboardingErrors, ThrowOnError> =>
  (options.client ?? client).patch<
    FactoriesUpdateFactoryOnboardingResponses,
    FactoriesUpdateFactoryOnboardingErrors,
    ThrowOnError
  >({
    url: "/api/v1/factories/{id}/onboarding",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Select a Factory VCS repository
 *
 * Selects an accessible VCS repository and creates the organization integration reference
 */
export const factoriesSelectFactoryVcsProviderRepository = <ThrowOnError extends boolean = true>(
  options: Options<FactoriesSelectFactoryVcsProviderRepositoryData, ThrowOnError>,
): RequestResult<
  FactoriesSelectFactoryVcsProviderRepositoryResponses,
  FactoriesSelectFactoryVcsProviderRepositoryErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    FactoriesSelectFactoryVcsProviderRepositoryResponses,
    FactoriesSelectFactoryVcsProviderRepositoryErrors,
    ThrowOnError
  >({
    url: "/api/v1/factories/{id}/onboarding/vcs-repository",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Update factory repository
 *
 * Updates the repository used by a factory workspace
 */
export const factoriesUpdateFactoryRepository = <ThrowOnError extends boolean = true>(
  options: Options<FactoriesUpdateFactoryRepositoryData, ThrowOnError>,
): RequestResult<FactoriesUpdateFactoryRepositoryResponses, FactoriesUpdateFactoryRepositoryErrors, ThrowOnError> =>
  (options.client ?? client).patch<
    FactoriesUpdateFactoryRepositoryResponses,
    FactoriesUpdateFactoryRepositoryErrors,
    ThrowOnError
  >({
    url: "/api/v1/factories/{id}/repository",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Set factory visibility
 *
 * Makes a workspace board public or private. Requires factories publish permission.
 */
export const factoriesSetFactoryVisibility = <ThrowOnError extends boolean = true>(
  options: Options<FactoriesSetFactoryVisibilityData, ThrowOnError>,
): RequestResult<FactoriesSetFactoryVisibilityResponses, FactoriesSetFactoryVisibilityErrors, ThrowOnError> =>
  (options.client ?? client).put<
    FactoriesSetFactoryVisibilityResponses,
    FactoriesSetFactoryVisibilityErrors,
    ThrowOnError
  >({
    url: "/api/v1/factories/{id}/visibility",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * List groups
 *
 * Returns a list of groups within a domain
 */
export const groupsListGroups = <ThrowOnError extends boolean = true>(
  options?: Options<GroupsListGroupsData, ThrowOnError>,
): RequestResult<GroupsListGroupsResponses, GroupsListGroupsErrors, ThrowOnError> =>
  (options?.client ?? client).get<GroupsListGroupsResponses, GroupsListGroupsErrors, ThrowOnError>({
    url: "/api/v1/groups",
    ...options,
  });

/**
 * Create group
 *
 * Creates a new group within a domain with a specific role
 */
export const groupsCreateGroup = <ThrowOnError extends boolean = true>(
  options: Options<GroupsCreateGroupData, ThrowOnError>,
): RequestResult<GroupsCreateGroupResponses, GroupsCreateGroupErrors, ThrowOnError> =>
  (options.client ?? client).post<GroupsCreateGroupResponses, GroupsCreateGroupErrors, ThrowOnError>({
    url: "/api/v1/groups",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Delete group
 *
 * Deletes an existing group within a domain
 */
export const groupsDeleteGroup = <ThrowOnError extends boolean = true>(
  options: Options<GroupsDeleteGroupData, ThrowOnError>,
): RequestResult<GroupsDeleteGroupResponses, GroupsDeleteGroupErrors, ThrowOnError> =>
  (options.client ?? client).delete<GroupsDeleteGroupResponses, GroupsDeleteGroupErrors, ThrowOnError>({
    url: "/api/v1/groups/{groupName}",
    ...options,
  });

/**
 * Get group
 *
 * Returns details of a specific group within a domain
 */
export const groupsDescribeGroup = <ThrowOnError extends boolean = true>(
  options: Options<GroupsDescribeGroupData, ThrowOnError>,
): RequestResult<GroupsDescribeGroupResponses, GroupsDescribeGroupErrors, ThrowOnError> =>
  (options.client ?? client).get<GroupsDescribeGroupResponses, GroupsDescribeGroupErrors, ThrowOnError>({
    url: "/api/v1/groups/{groupName}",
    ...options,
  });

/**
 * Update group
 *
 * Updates an existing group within a domain
 */
export const groupsUpdateGroup = <ThrowOnError extends boolean = true>(
  options: Options<GroupsUpdateGroupData, ThrowOnError>,
): RequestResult<GroupsUpdateGroupResponses, GroupsUpdateGroupErrors, ThrowOnError> =>
  (options.client ?? client).put<GroupsUpdateGroupResponses, GroupsUpdateGroupErrors, ThrowOnError>({
    url: "/api/v1/groups/{groupName}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Get group users
 *
 * Returns users that belong to a specific group within a domain
 */
export const groupsListGroupUsers = <ThrowOnError extends boolean = true>(
  options: Options<GroupsListGroupUsersData, ThrowOnError>,
): RequestResult<GroupsListGroupUsersResponses, GroupsListGroupUsersErrors, ThrowOnError> =>
  (options.client ?? client).get<GroupsListGroupUsersResponses, GroupsListGroupUsersErrors, ThrowOnError>({
    url: "/api/v1/groups/{groupName}/users",
    ...options,
  });

/**
 * Add user to group
 *
 * Adds a user to a group within a domain
 */
export const groupsAddUserToGroup = <ThrowOnError extends boolean = true>(
  options: Options<GroupsAddUserToGroupData, ThrowOnError>,
): RequestResult<GroupsAddUserToGroupResponses, GroupsAddUserToGroupErrors, ThrowOnError> =>
  (options.client ?? client).post<GroupsAddUserToGroupResponses, GroupsAddUserToGroupErrors, ThrowOnError>({
    url: "/api/v1/groups/{groupName}/users",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Remove user from group
 *
 * Removes a user from a group within a domain
 */
export const groupsRemoveUserFromGroup = <ThrowOnError extends boolean = true>(
  options: Options<GroupsRemoveUserFromGroupData, ThrowOnError>,
): RequestResult<GroupsRemoveUserFromGroupResponses, GroupsRemoveUserFromGroupErrors, ThrowOnError> =>
  (options.client ?? client).patch<GroupsRemoveUserFromGroupResponses, GroupsRemoveUserFromGroupErrors, ThrowOnError>({
    url: "/api/v1/groups/{groupName}/users/remove",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * List available integrations
 *
 * List available integrations
 */
export const integrationsListIntegrations = <ThrowOnError extends boolean = true>(
  options?: Options<IntegrationsListIntegrationsData, ThrowOnError>,
): RequestResult<IntegrationsListIntegrationsResponses, IntegrationsListIntegrationsErrors, ThrowOnError> =>
  (options?.client ?? client).get<
    IntegrationsListIntegrationsResponses,
    IntegrationsListIntegrationsErrors,
    ThrowOnError
  >({ url: "/api/v1/integrations", ...options });

/**
 * Accept an invite link
 *
 * Accepts an organization invite link for the authenticated account
 */
export const organizationsAcceptInviteLink = <ThrowOnError extends boolean = true>(
  options: Options<OrganizationsAcceptInviteLinkData, ThrowOnError>,
): RequestResult<OrganizationsAcceptInviteLinkResponses, OrganizationsAcceptInviteLinkErrors, ThrowOnError> =>
  (options.client ?? client).post<
    OrganizationsAcceptInviteLinkResponses,
    OrganizationsAcceptInviteLinkErrors,
    ThrowOnError
  >({ url: "/api/v1/invite-links/{token}/accept", ...options });

/**
 * Get current user
 *
 * Returns the currently authenticated user
 */
export const meMe = <ThrowOnError extends boolean = true>(
  options?: Options<MeMeData, ThrowOnError>,
): RequestResult<MeMeResponses, MeMeErrors, ThrowOnError> =>
  (options?.client ?? client).get<MeMeResponses, MeMeErrors, ThrowOnError>({ url: "/api/v1/me", ...options });

/**
 * Describe last location
 *
 * Returns the last in-app screen the calling user visited, if any was saved
 */
export const meDescribeLastLocation = <ThrowOnError extends boolean = true>(
  options?: Options<MeDescribeLastLocationData, ThrowOnError>,
): RequestResult<MeDescribeLastLocationResponses, MeDescribeLastLocationErrors, ThrowOnError> =>
  (options?.client ?? client).get<MeDescribeLastLocationResponses, MeDescribeLastLocationErrors, ThrowOnError>({
    url: "/api/v1/me/last-location",
    ...options,
  });

/**
 * Save last location
 *
 * Saves the last in-app screen the calling user visited
 */
export const meSaveLastLocation = <ThrowOnError extends boolean = true>(
  options: Options<MeSaveLastLocationData, ThrowOnError>,
): RequestResult<MeSaveLastLocationResponses, MeSaveLastLocationErrors, ThrowOnError> =>
  (options.client ?? client).put<MeSaveLastLocationResponses, MeSaveLastLocationErrors, ThrowOnError>({
    url: "/api/v1/me/last-location",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Describe notification settings
 *
 * Returns the calling user's work order notification settings
 */
export const meDescribeNotificationSettings = <ThrowOnError extends boolean = true>(
  options?: Options<MeDescribeNotificationSettingsData, ThrowOnError>,
): RequestResult<MeDescribeNotificationSettingsResponses, MeDescribeNotificationSettingsErrors, ThrowOnError> =>
  (options?.client ?? client).get<
    MeDescribeNotificationSettingsResponses,
    MeDescribeNotificationSettingsErrors,
    ThrowOnError
  >({ url: "/api/v1/me/notification-settings", ...options });

/**
 * Update notification settings
 *
 * Updates the calling user's work order notification settings
 */
export const meUpdateNotificationSettings = <ThrowOnError extends boolean = true>(
  options: Options<MeUpdateNotificationSettingsData, ThrowOnError>,
): RequestResult<MeUpdateNotificationSettingsResponses, MeUpdateNotificationSettingsErrors, ThrowOnError> =>
  (options.client ?? client).put<
    MeUpdateNotificationSettingsResponses,
    MeUpdateNotificationSettingsErrors,
    ThrowOnError
  >({
    url: "/api/v1/me/notification-settings",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Regenerate API token
 *
 * Regenerates the currently authencated user's API token
 */
export const meRegenerateToken = <ThrowOnError extends boolean = true>(
  options?: Options<MeRegenerateTokenData, ThrowOnError>,
): RequestResult<MeRegenerateTokenResponses, MeRegenerateTokenErrors, ThrowOnError> =>
  (options?.client ?? client).post<MeRegenerateTokenResponses, MeRegenerateTokenErrors, ThrowOnError>({
    url: "/api/v1/me/token",
    ...options,
  });

/**
 * List personal API tokens
 *
 * Returns the calling user's personal API tokens, without their secrets
 */
export const meListTokens = <ThrowOnError extends boolean = true>(
  options?: Options<MeListTokensData, ThrowOnError>,
): RequestResult<MeListTokensResponses, MeListTokensErrors, ThrowOnError> =>
  (options?.client ?? client).get<MeListTokensResponses, MeListTokensErrors, ThrowOnError>({
    url: "/api/v1/me/tokens",
    ...options,
  });

/**
 * Create a personal API token
 *
 * Creates a new named personal API token and returns its plaintext secret once
 */
export const meCreateToken = <ThrowOnError extends boolean = true>(
  options: Options<MeCreateTokenData, ThrowOnError>,
): RequestResult<MeCreateTokenResponses, MeCreateTokenErrors, ThrowOnError> =>
  (options.client ?? client).post<MeCreateTokenResponses, MeCreateTokenErrors, ThrowOnError>({
    url: "/api/v1/me/tokens",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Revoke a personal API token
 *
 * Revokes a personal API token without affecting the caller's other tokens
 */
export const meRevokeToken = <ThrowOnError extends boolean = true>(
  options: Options<MeRevokeTokenData, ThrowOnError>,
): RequestResult<MeRevokeTokenResponses, MeRevokeTokenErrors, ThrowOnError> =>
  (options.client ?? client).delete<MeRevokeTokenResponses, MeRevokeTokenErrors, ThrowOnError>({
    url: "/api/v1/me/tokens/{id}",
    ...options,
  });

/**
 * Select a VCS provider identity
 *
 * Selects the linked identity that supplies repositories during onboarding
 */
export const meSelectVcsProviderOnboardingIdentity = <ThrowOnError extends boolean = true>(
  options: Options<MeSelectVcsProviderOnboardingIdentityData, ThrowOnError>,
): RequestResult<
  MeSelectVcsProviderOnboardingIdentityResponses,
  MeSelectVcsProviderOnboardingIdentityErrors,
  ThrowOnError
> =>
  (options.client ?? client).put<
    MeSelectVcsProviderOnboardingIdentityResponses,
    MeSelectVcsProviderOnboardingIdentityErrors,
    ThrowOnError
  >({
    url: "/api/v1/me/vcs/{provider}/identity",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Configure a VCS provider installation
 *
 * Returns the settings URL for an existing VCS provider installation
 */
export const meConfigureVcsProviderInstallation = <ThrowOnError extends boolean = true>(
  options: Options<MeConfigureVcsProviderInstallationData, ThrowOnError>,
): RequestResult<MeConfigureVcsProviderInstallationResponses, MeConfigureVcsProviderInstallationErrors, ThrowOnError> =>
  (options.client ?? client).post<
    MeConfigureVcsProviderInstallationResponses,
    MeConfigureVcsProviderInstallationErrors,
    ThrowOnError
  >({
    url: "/api/v1/me/vcs/{provider}/installations/{installationId}:configure",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Start a VCS provider installation
 *
 * Returns the installation URL for the selected VCS provider
 */
export const meStartVcsProviderInstallation = <ThrowOnError extends boolean = true>(
  options: Options<MeStartVcsProviderInstallationData, ThrowOnError>,
): RequestResult<MeStartVcsProviderInstallationResponses, MeStartVcsProviderInstallationErrors, ThrowOnError> =>
  (options.client ?? client).post<
    MeStartVcsProviderInstallationResponses,
    MeStartVcsProviderInstallationErrors,
    ThrowOnError
  >({
    url: "/api/v1/me/vcs/{provider}/installations:start",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Verify VCS provider installations
 *
 * Checks with the VCS provider that the installations the user can see still exist, and removes the installations that were uninstalled
 */
export const meVerifyVcsProviderInstallations = <ThrowOnError extends boolean = true>(
  options: Options<MeVerifyVcsProviderInstallationsData, ThrowOnError>,
): RequestResult<MeVerifyVcsProviderInstallationsResponses, MeVerifyVcsProviderInstallationsErrors, ThrowOnError> =>
  (options.client ?? client).post<
    MeVerifyVcsProviderInstallationsResponses,
    MeVerifyVcsProviderInstallationsErrors,
    ThrowOnError
  >({
    url: "/api/v1/me/vcs/{provider}/installations:verify",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Describe VCS provider onboarding
 *
 * Returns linked identities, the active identity, accessible repositories, and pending installation requests for a VCS provider
 */
export const meDescribeVcsProviderOnboarding = <ThrowOnError extends boolean = true>(
  options: Options<MeDescribeVcsProviderOnboardingData, ThrowOnError>,
): RequestResult<MeDescribeVcsProviderOnboardingResponses, MeDescribeVcsProviderOnboardingErrors, ThrowOnError> =>
  (options.client ?? client).get<
    MeDescribeVcsProviderOnboardingResponses,
    MeDescribeVcsProviderOnboardingErrors,
    ThrowOnError
  >({ url: "/api/v1/me/vcs/{provider}/onboarding", ...options });

/**
 * Refresh VCS provider repositories
 *
 * Queues catalog reconciliation and collaborator synchronization for the selected VCS provider
 */
export const meRefreshVcsProviderOnboarding = <ThrowOnError extends boolean = true>(
  options: Options<MeRefreshVcsProviderOnboardingData, ThrowOnError>,
): RequestResult<MeRefreshVcsProviderOnboardingResponses, MeRefreshVcsProviderOnboardingErrors, ThrowOnError> =>
  (options.client ?? client).post<
    MeRefreshVcsProviderOnboardingResponses,
    MeRefreshVcsProviderOnboardingErrors,
    ThrowOnError
  >({
    url: "/api/v1/me/vcs/{provider}/repositories:refresh",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Delete an organization
 *
 * Deletes the specified organization (can be referenced by ID or name)
 */
export const organizationsDeleteOrganization = <ThrowOnError extends boolean = true>(
  options: Options<OrganizationsDeleteOrganizationData, ThrowOnError>,
): RequestResult<OrganizationsDeleteOrganizationResponses, OrganizationsDeleteOrganizationErrors, ThrowOnError> =>
  (options.client ?? client).delete<
    OrganizationsDeleteOrganizationResponses,
    OrganizationsDeleteOrganizationErrors,
    ThrowOnError
  >({ url: "/api/v1/organizations/{id}", ...options });

/**
 * Get organization details
 *
 * Returns the details of a specific organization (can be referenced by ID or slug)
 */
export const organizationsDescribeOrganization = <ThrowOnError extends boolean = true>(
  options: Options<OrganizationsDescribeOrganizationData, ThrowOnError>,
): RequestResult<OrganizationsDescribeOrganizationResponses, OrganizationsDescribeOrganizationErrors, ThrowOnError> =>
  (options.client ?? client).get<
    OrganizationsDescribeOrganizationResponses,
    OrganizationsDescribeOrganizationErrors,
    ThrowOnError
  >({ url: "/api/v1/organizations/{id}", ...options });

/**
 * Update an organization
 *
 * Updates the specified organization (can be referenced by ID or slug). Set metadata.slug to change the organization's URL slug.
 */
export const organizationsUpdateOrganization = <ThrowOnError extends boolean = true>(
  options: Options<OrganizationsUpdateOrganizationData, ThrowOnError>,
): RequestResult<OrganizationsUpdateOrganizationResponses, OrganizationsUpdateOrganizationErrors, ThrowOnError> =>
  (options.client ?? client).patch<
    OrganizationsUpdateOrganizationResponses,
    OrganizationsUpdateOrganizationErrors,
    ThrowOnError
  >({
    url: "/api/v1/organizations/{id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Describe organization billing
 *
 * Returns the organization plan, trial window, and hosted-credit remaining amounts
 */
export const organizationsDescribeOrganizationBilling = <ThrowOnError extends boolean = true>(
  options: Options<OrganizationsDescribeOrganizationBillingData, ThrowOnError>,
): RequestResult<
  OrganizationsDescribeOrganizationBillingResponses,
  OrganizationsDescribeOrganizationBillingErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    OrganizationsDescribeOrganizationBillingResponses,
    OrganizationsDescribeOrganizationBillingErrors,
    ThrowOnError
  >({ url: "/api/v1/organizations/{id}/billing", ...options });

/**
 * Create billing portal session
 *
 * Creates a customer portal session for invoices and receipts
 */
export const organizationsCreateBillingPortalSession = <ThrowOnError extends boolean = true>(
  options: Options<OrganizationsCreateBillingPortalSessionData, ThrowOnError>,
): RequestResult<
  OrganizationsCreateBillingPortalSessionResponses,
  OrganizationsCreateBillingPortalSessionErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    OrganizationsCreateBillingPortalSessionResponses,
    OrganizationsCreateBillingPortalSessionErrors,
    ThrowOnError
  >({
    url: "/api/v1/organizations/{id}/billing-portal-session",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Cancel organization subscription
 *
 * Cancels the Polar Business subscription at the end of the current period
 */
export const organizationsCancelOrganizationSubscription = <ThrowOnError extends boolean = true>(
  options: Options<OrganizationsCancelOrganizationSubscriptionData, ThrowOnError>,
): RequestResult<
  OrganizationsCancelOrganizationSubscriptionResponses,
  OrganizationsCancelOrganizationSubscriptionErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    OrganizationsCancelOrganizationSubscriptionResponses,
    OrganizationsCancelOrganizationSubscriptionErrors,
    ThrowOnError
  >({
    url: "/api/v1/organizations/{id}/billing/cancel",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Resume organization subscription
 *
 * Clears a scheduled Polar Business cancellation so the subscription renews
 */
export const organizationsResumeOrganizationSubscription = <ThrowOnError extends boolean = true>(
  options: Options<OrganizationsResumeOrganizationSubscriptionData, ThrowOnError>,
): RequestResult<
  OrganizationsResumeOrganizationSubscriptionResponses,
  OrganizationsResumeOrganizationSubscriptionErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    OrganizationsResumeOrganizationSubscriptionResponses,
    OrganizationsResumeOrganizationSubscriptionErrors,
    ThrowOnError
  >({
    url: "/api/v1/organizations/{id}/billing/resume",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Sync organization billing
 *
 * Reads the Polar Business subscription for the organization and updates the local plan
 */
export const organizationsSyncOrganizationBilling = <ThrowOnError extends boolean = true>(
  options: Options<OrganizationsSyncOrganizationBillingData, ThrowOnError>,
): RequestResult<
  OrganizationsSyncOrganizationBillingResponses,
  OrganizationsSyncOrganizationBillingErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    OrganizationsSyncOrganizationBillingResponses,
    OrganizationsSyncOrganizationBillingErrors,
    ThrowOnError
  >({
    url: "/api/v1/organizations/{id}/billing/sync",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Create Business checkout
 *
 * Creates a Polar checkout session for the Business subscription
 */
export const organizationsCreateBusinessCheckout = <ThrowOnError extends boolean = true>(
  options: Options<OrganizationsCreateBusinessCheckoutData, ThrowOnError>,
): RequestResult<
  OrganizationsCreateBusinessCheckoutResponses,
  OrganizationsCreateBusinessCheckoutErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    OrganizationsCreateBusinessCheckoutResponses,
    OrganizationsCreateBusinessCheckoutErrors,
    ThrowOnError
  >({
    url: "/api/v1/organizations/{id}/business-checkout",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * List BYOK LLM models
 *
 * Returns the organization selected-model list and candidate models from the connected provider key
 */
export const organizationsListByokllmModels = <ThrowOnError extends boolean = true>(
  options: Options<OrganizationsListByokllmModelsData, ThrowOnError>,
): RequestResult<OrganizationsListByokllmModelsResponses, OrganizationsListByokllmModelsErrors, ThrowOnError> =>
  (options.client ?? client).get<
    OrganizationsListByokllmModelsResponses,
    OrganizationsListByokllmModelsErrors,
    ThrowOnError
  >({ url: "/api/v1/organizations/{id}/byok-models", ...options });

/**
 * Update BYOK LLM models
 *
 * Replaces the organization selected-model list for one BYOK provider
 */
export const organizationsUpdateByokllmModels = <ThrowOnError extends boolean = true>(
  options: Options<OrganizationsUpdateByokllmModelsData, ThrowOnError>,
): RequestResult<OrganizationsUpdateByokllmModelsResponses, OrganizationsUpdateByokllmModelsErrors, ThrowOnError> =>
  (options.client ?? client).put<
    OrganizationsUpdateByokllmModelsResponses,
    OrganizationsUpdateByokllmModelsErrors,
    ThrowOnError
  >({
    url: "/api/v1/organizations/{id}/byok-models",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * List organization credit grants
 *
 * Returns hosted-credit grants for an organization, newest first
 */
export const organizationsListOrganizationCreditGrants = <ThrowOnError extends boolean = true>(
  options: Options<OrganizationsListOrganizationCreditGrantsData, ThrowOnError>,
): RequestResult<
  OrganizationsListOrganizationCreditGrantsResponses,
  OrganizationsListOrganizationCreditGrantsErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    OrganizationsListOrganizationCreditGrantsResponses,
    OrganizationsListOrganizationCreditGrantsErrors,
    ThrowOnError
  >({ url: "/api/v1/organizations/{id}/credit-grants", ...options });

/**
 * List organization runner fleets
 *
 * Returns the runner fleets that the organization can select
 */
export const organizationsListOrganizationRunnerFleets = <ThrowOnError extends boolean = true>(
  options: Options<OrganizationsListOrganizationRunnerFleetsData, ThrowOnError>,
): RequestResult<
  OrganizationsListOrganizationRunnerFleetsResponses,
  OrganizationsListOrganizationRunnerFleetsErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    OrganizationsListOrganizationRunnerFleetsResponses,
    OrganizationsListOrganizationRunnerFleetsErrors,
    ThrowOnError
  >({ url: "/api/v1/organizations/{id}/fleets", ...options });

/**
 * Create hosted credit checkout
 *
 * Creates a checkout session for a prepaid hosted-credit pack
 */
export const organizationsCreateHostedCreditCheckout = <ThrowOnError extends boolean = true>(
  options: Options<OrganizationsCreateHostedCreditCheckoutData, ThrowOnError>,
): RequestResult<
  OrganizationsCreateHostedCreditCheckoutResponses,
  OrganizationsCreateHostedCreditCheckoutErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    OrganizationsCreateHostedCreditCheckoutResponses,
    OrganizationsCreateHostedCreditCheckoutErrors,
    ThrowOnError
  >({
    url: "/api/v1/organizations/{id}/hosted-credit-checkout",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * List hosted credit products
 *
 * Returns prepaid hosted-credit packs when billing is configured
 */
export const organizationsListHostedCreditProducts = <ThrowOnError extends boolean = true>(
  options: Options<OrganizationsListHostedCreditProductsData, ThrowOnError>,
): RequestResult<
  OrganizationsListHostedCreditProductsResponses,
  OrganizationsListHostedCreditProductsErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    OrganizationsListHostedCreditProductsResponses,
    OrganizationsListHostedCreditProductsErrors,
    ThrowOnError
  >({ url: "/api/v1/organizations/{id}/hosted-credit-products", ...options });

/**
 * List hosted LLM models
 *
 * Returns the SuperPlane-hosted model allowlist for one provider
 */
export const organizationsListHostedLlmModels = <ThrowOnError extends boolean = true>(
  options: Options<OrganizationsListHostedLlmModelsData, ThrowOnError>,
): RequestResult<OrganizationsListHostedLlmModelsResponses, OrganizationsListHostedLlmModelsErrors, ThrowOnError> =>
  (options.client ?? client).get<
    OrganizationsListHostedLlmModelsResponses,
    OrganizationsListHostedLlmModelsErrors,
    ThrowOnError
  >({ url: "/api/v1/organizations/{id}/hosted-llm-models", ...options });

/**
 * List organization hosted models
 *
 * Returns installation model candidates and the organization selection for every hosted provider
 */
export const organizationsListOrganizationHostedLlmModels = <ThrowOnError extends boolean = true>(
  options: Options<OrganizationsListOrganizationHostedLlmModelsData, ThrowOnError>,
): RequestResult<
  OrganizationsListOrganizationHostedLlmModelsResponses,
  OrganizationsListOrganizationHostedLlmModelsErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    OrganizationsListOrganizationHostedLlmModelsResponses,
    OrganizationsListOrganizationHostedLlmModelsErrors,
    ThrowOnError
  >({ url: "/api/v1/organizations/{id}/hosted-models", ...options });

/**
 * Update organization hosted models
 *
 * Replaces the organization selection for every hosted provider
 */
export const organizationsUpdateOrganizationHostedLlmModels = <ThrowOnError extends boolean = true>(
  options: Options<OrganizationsUpdateOrganizationHostedLlmModelsData, ThrowOnError>,
): RequestResult<
  OrganizationsUpdateOrganizationHostedLlmModelsResponses,
  OrganizationsUpdateOrganizationHostedLlmModelsErrors,
  ThrowOnError
> =>
  (options.client ?? client).put<
    OrganizationsUpdateOrganizationHostedLlmModelsResponses,
    OrganizationsUpdateOrganizationHostedLlmModelsErrors,
    ThrowOnError
  >({
    url: "/api/v1/organizations/{id}/hosted-models",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * List integrations in an organization
 *
 * Returns a list of integrations in an organization
 */
export const organizationsListIntegrations = <ThrowOnError extends boolean = true>(
  options: Options<OrganizationsListIntegrationsData, ThrowOnError>,
): RequestResult<OrganizationsListIntegrationsResponses, OrganizationsListIntegrationsErrors, ThrowOnError> =>
  (options.client ?? client).get<
    OrganizationsListIntegrationsResponses,
    OrganizationsListIntegrationsErrors,
    ThrowOnError
  >({ url: "/api/v1/organizations/{id}/integrations", ...options });

/**
 * Create organization integration
 *
 * Create an organization integration
 */
export const organizationsCreateIntegration = <ThrowOnError extends boolean = true>(
  options: Options<OrganizationsCreateIntegrationData, ThrowOnError>,
): RequestResult<OrganizationsCreateIntegrationResponses, OrganizationsCreateIntegrationErrors, ThrowOnError> =>
  (options.client ?? client).post<
    OrganizationsCreateIntegrationResponses,
    OrganizationsCreateIntegrationErrors,
    ThrowOnError
  >({
    url: "/api/v1/organizations/{id}/integrations",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Delete organization integration
 *
 * Deletes an integration from an organization
 */
export const organizationsDeleteIntegration = <ThrowOnError extends boolean = true>(
  options: Options<OrganizationsDeleteIntegrationData, ThrowOnError>,
): RequestResult<OrganizationsDeleteIntegrationResponses, OrganizationsDeleteIntegrationErrors, ThrowOnError> =>
  (options.client ?? client).delete<
    OrganizationsDeleteIntegrationResponses,
    OrganizationsDeleteIntegrationErrors,
    ThrowOnError
  >({ url: "/api/v1/organizations/{id}/integrations/{integrationId}", ...options });

/**
 * Describe an integration in an organization
 *
 * Returns details of a specific integration in an organization
 */
export const organizationsDescribeIntegration = <ThrowOnError extends boolean = true>(
  options: Options<OrganizationsDescribeIntegrationData, ThrowOnError>,
): RequestResult<OrganizationsDescribeIntegrationResponses, OrganizationsDescribeIntegrationErrors, ThrowOnError> =>
  (options.client ?? client).get<
    OrganizationsDescribeIntegrationResponses,
    OrganizationsDescribeIntegrationErrors,
    ThrowOnError
  >({ url: "/api/v1/organizations/{id}/integrations/{integrationId}", ...options });

/**
 * Update integration
 *
 * Updates the configuration for an organization integration
 */
export const organizationsUpdateIntegration = <ThrowOnError extends boolean = true>(
  options: Options<OrganizationsUpdateIntegrationData, ThrowOnError>,
): RequestResult<OrganizationsUpdateIntegrationResponses, OrganizationsUpdateIntegrationErrors, ThrowOnError> =>
  (options.client ?? client).patch<
    OrganizationsUpdateIntegrationResponses,
    OrganizationsUpdateIntegrationErrors,
    ThrowOnError
  >({
    url: "/api/v1/organizations/{id}/integrations/{integrationId}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Update integration capabilities
 *
 * Update integration capabilities
 */
export const organizationsUpdateIntegrationCapabilities = <ThrowOnError extends boolean = true>(
  options: Options<OrganizationsUpdateIntegrationCapabilitiesData, ThrowOnError>,
): RequestResult<
  OrganizationsUpdateIntegrationCapabilitiesResponses,
  OrganizationsUpdateIntegrationCapabilitiesErrors,
  ThrowOnError
> =>
  (options.client ?? client).put<
    OrganizationsUpdateIntegrationCapabilitiesResponses,
    OrganizationsUpdateIntegrationCapabilitiesErrors,
    ThrowOnError
  >({
    url: "/api/v1/organizations/{id}/integrations/{integrationId}/capabilities",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Submit an integration setup step and go to the next
 *
 * Submit an integration setup step and go to the next
 */
export const organizationsNextIntegrationSetupStep = <ThrowOnError extends boolean = true>(
  options: Options<OrganizationsNextIntegrationSetupStepData, ThrowOnError>,
): RequestResult<
  OrganizationsNextIntegrationSetupStepResponses,
  OrganizationsNextIntegrationSetupStepErrors,
  ThrowOnError
> =>
  (options.client ?? client).patch<
    OrganizationsNextIntegrationSetupStepResponses,
    OrganizationsNextIntegrationSetupStepErrors,
    ThrowOnError
  >({
    url: "/api/v1/organizations/{id}/integrations/{integrationId}/next",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Revert the current integration setup step and go to the previous
 *
 * Revert the current integration setup step and go to the previous
 */
export const organizationsPreviousIntegrationSetupStep = <ThrowOnError extends boolean = true>(
  options: Options<OrganizationsPreviousIntegrationSetupStepData, ThrowOnError>,
): RequestResult<
  OrganizationsPreviousIntegrationSetupStepResponses,
  OrganizationsPreviousIntegrationSetupStepErrors,
  ThrowOnError
> =>
  (options.client ?? client).patch<
    OrganizationsPreviousIntegrationSetupStepResponses,
    OrganizationsPreviousIntegrationSetupStepErrors,
    ThrowOnError
  >({
    url: "/api/v1/organizations/{id}/integrations/{integrationId}/previous",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Update integration property
 *
 * Update integration property
 */
export const organizationsUpdateIntegrationProperty = <ThrowOnError extends boolean = true>(
  options: Options<OrganizationsUpdateIntegrationPropertyData, ThrowOnError>,
): RequestResult<
  OrganizationsUpdateIntegrationPropertyResponses,
  OrganizationsUpdateIntegrationPropertyErrors,
  ThrowOnError
> =>
  (options.client ?? client).put<
    OrganizationsUpdateIntegrationPropertyResponses,
    OrganizationsUpdateIntegrationPropertyErrors,
    ThrowOnError
  >({
    url: "/api/v1/organizations/{id}/integrations/{integrationId}/properties",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * List integration resources
 *
 * Lists resources for an integration
 */
export const organizationsListIntegrationResources = <ThrowOnError extends boolean = true>(
  options: Options<OrganizationsListIntegrationResourcesData, ThrowOnError>,
): RequestResult<
  OrganizationsListIntegrationResourcesResponses,
  OrganizationsListIntegrationResourcesErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    OrganizationsListIntegrationResourcesResponses,
    OrganizationsListIntegrationResourcesErrors,
    ThrowOnError
  >({ url: "/api/v1/organizations/{id}/integrations/{integrationId}/resources", ...options });

/**
 * Update integration secret
 *
 * Update integration secret
 */
export const organizationsUpdateIntegrationSecret = <ThrowOnError extends boolean = true>(
  options: Options<OrganizationsUpdateIntegrationSecretData, ThrowOnError>,
): RequestResult<
  OrganizationsUpdateIntegrationSecretResponses,
  OrganizationsUpdateIntegrationSecretErrors,
  ThrowOnError
> =>
  (options.client ?? client).put<
    OrganizationsUpdateIntegrationSecretResponses,
    OrganizationsUpdateIntegrationSecretErrors,
    ThrowOnError
  >({
    url: "/api/v1/organizations/{id}/integrations/{integrationId}/secrets",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Get an organization invite link
 *
 * Returns the invite link for an organization
 */
export const organizationsGetInviteLink = <ThrowOnError extends boolean = true>(
  options: Options<OrganizationsGetInviteLinkData, ThrowOnError>,
): RequestResult<OrganizationsGetInviteLinkResponses, OrganizationsGetInviteLinkErrors, ThrowOnError> =>
  (options.client ?? client).get<OrganizationsGetInviteLinkResponses, OrganizationsGetInviteLinkErrors, ThrowOnError>({
    url: "/api/v1/organizations/{id}/invite-link",
    ...options,
  });

/**
 * Update an organization invite link
 *
 * Enables or disables the invite link for an organization
 */
export const organizationsUpdateInviteLink = <ThrowOnError extends boolean = true>(
  options: Options<OrganizationsUpdateInviteLinkData, ThrowOnError>,
): RequestResult<OrganizationsUpdateInviteLinkResponses, OrganizationsUpdateInviteLinkErrors, ThrowOnError> =>
  (options.client ?? client).patch<
    OrganizationsUpdateInviteLinkResponses,
    OrganizationsUpdateInviteLinkErrors,
    ThrowOnError
  >({
    url: "/api/v1/organizations/{id}/invite-link",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Reset an organization invite link
 *
 * Generates a new invite link token for an organization
 */
export const organizationsResetInviteLink = <ThrowOnError extends boolean = true>(
  options: Options<OrganizationsResetInviteLinkData, ThrowOnError>,
): RequestResult<OrganizationsResetInviteLinkResponses, OrganizationsResetInviteLinkErrors, ThrowOnError> =>
  (options.client ?? client).post<
    OrganizationsResetInviteLinkResponses,
    OrganizationsResetInviteLinkErrors,
    ThrowOnError
  >({ url: "/api/v1/organizations/{id}/invite-link/reset", ...options });

/**
 * List selectable LLM models
 *
 * Returns SuperPlane-hosted and selected BYOK models a picker may show
 */
export const organizationsListSelectableLlmModels = <ThrowOnError extends boolean = true>(
  options: Options<OrganizationsListSelectableLlmModelsData, ThrowOnError>,
): RequestResult<
  OrganizationsListSelectableLlmModelsResponses,
  OrganizationsListSelectableLlmModelsErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    OrganizationsListSelectableLlmModelsResponses,
    OrganizationsListSelectableLlmModelsErrors,
    ThrowOnError
  >({ url: "/api/v1/organizations/{id}/selectable-llm-models", ...options });

/**
 * Describe organization spending report
 *
 * Returns aggregated spending KPIs, chart series, and breakdown rows for the organization spending explorer
 */
export const organizationsDescribeOrganizationSpendingReport = <ThrowOnError extends boolean = true>(
  options: Options<OrganizationsDescribeOrganizationSpendingReportData, ThrowOnError>,
): RequestResult<
  OrganizationsDescribeOrganizationSpendingReportResponses,
  OrganizationsDescribeOrganizationSpendingReportErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    OrganizationsDescribeOrganizationSpendingReportResponses,
    OrganizationsDescribeOrganizationSpendingReportErrors,
    ThrowOnError
  >({ url: "/api/v1/organizations/{id}/spending-report", ...options });

/**
 * Remove a user from an organization
 *
 * Removes a user from an organization (can be referenced by ID or name)
 */
export const organizationsRemoveUser = <ThrowOnError extends boolean = true>(
  options: Options<OrganizationsRemoveUserData, ThrowOnError>,
): RequestResult<OrganizationsRemoveUserResponses, OrganizationsRemoveUserErrors, ThrowOnError> =>
  (options.client ?? client).delete<OrganizationsRemoveUserResponses, OrganizationsRemoveUserErrors, ThrowOnError>({
    url: "/api/v1/organizations/{id}/users/{userId}",
    ...options,
  });

/**
 * Set organization owner flag
 *
 * Sets or clears the owner flag for a member. The organization must keep at least one owner.
 */
export const organizationsSetUserOwner = <ThrowOnError extends boolean = true>(
  options: Options<OrganizationsSetUserOwnerData, ThrowOnError>,
): RequestResult<OrganizationsSetUserOwnerResponses, OrganizationsSetUserOwnerErrors, ThrowOnError> =>
  (options.client ?? client).patch<OrganizationsSetUserOwnerResponses, OrganizationsSetUserOwnerErrors, ThrowOnError>({
    url: "/api/v1/organizations/{id}/users/{userId}/owner",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Describe organization workspace usage
 *
 * Returns token, VM seconds, and estimated dollar spend for factory runs, grouped by model and machine type
 */
export const organizationsDescribeOrganizationWorkspaceUsage = <ThrowOnError extends boolean = true>(
  options: Options<OrganizationsDescribeOrganizationWorkspaceUsageData, ThrowOnError>,
): RequestResult<
  OrganizationsDescribeOrganizationWorkspaceUsageResponses,
  OrganizationsDescribeOrganizationWorkspaceUsageErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    OrganizationsDescribeOrganizationWorkspaceUsageResponses,
    OrganizationsDescribeOrganizationWorkspaceUsageErrors,
    ThrowOnError
  >({ url: "/api/v1/organizations/{id}/workspace-usage", ...options });

/**
 * List roles
 *
 * Returns available roles for a specific domain type with their permissions and inheritance
 */
export const rolesListRoles = <ThrowOnError extends boolean = true>(
  options?: Options<RolesListRolesData, ThrowOnError>,
): RequestResult<RolesListRolesResponses, RolesListRolesErrors, ThrowOnError> =>
  (options?.client ?? client).get<RolesListRolesResponses, RolesListRolesErrors, ThrowOnError>({
    url: "/api/v1/roles",
    ...options,
  });

/**
 * Create role
 *
 * Creates a new custom role with specified permissions
 */
export const rolesCreateRole = <ThrowOnError extends boolean = true>(
  options: Options<RolesCreateRoleData, ThrowOnError>,
): RequestResult<RolesCreateRoleResponses, RolesCreateRoleErrors, ThrowOnError> =>
  (options.client ?? client).post<RolesCreateRoleResponses, RolesCreateRoleErrors, ThrowOnError>({
    url: "/api/v1/roles",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Delete role
 *
 * Deletes an existing custom role
 */
export const rolesDeleteRole = <ThrowOnError extends boolean = true>(
  options: Options<RolesDeleteRoleData, ThrowOnError>,
): RequestResult<RolesDeleteRoleResponses, RolesDeleteRoleErrors, ThrowOnError> =>
  (options.client ?? client).delete<RolesDeleteRoleResponses, RolesDeleteRoleErrors, ThrowOnError>({
    url: "/api/v1/roles/{roleName}",
    ...options,
  });

/**
 * Describe role
 *
 * Returns detailed information about a specific role including permissions and inheritance
 */
export const rolesDescribeRole = <ThrowOnError extends boolean = true>(
  options: Options<RolesDescribeRoleData, ThrowOnError>,
): RequestResult<RolesDescribeRoleResponses, RolesDescribeRoleErrors, ThrowOnError> =>
  (options.client ?? client).get<RolesDescribeRoleResponses, RolesDescribeRoleErrors, ThrowOnError>({
    url: "/api/v1/roles/{roleName}",
    ...options,
  });

/**
 * Update role
 *
 * Updates an existing custom role with new permissions
 */
export const rolesUpdateRole = <ThrowOnError extends boolean = true>(
  options: Options<RolesUpdateRoleData, ThrowOnError>,
): RequestResult<RolesUpdateRoleResponses, RolesUpdateRoleErrors, ThrowOnError> =>
  (options.client ?? client).put<RolesUpdateRoleResponses, RolesUpdateRoleErrors, ThrowOnError>({
    url: "/api/v1/roles/{roleName}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Assign role
 *
 * Assigns a role to a user within a domain
 */
export const rolesAssignRole = <ThrowOnError extends boolean = true>(
  options: Options<RolesAssignRoleData, ThrowOnError>,
): RequestResult<RolesAssignRoleResponses, RolesAssignRoleErrors, ThrowOnError> =>
  (options.client ?? client).post<RolesAssignRoleResponses, RolesAssignRoleErrors, ThrowOnError>({
    url: "/api/v1/roles/{roleName}/users",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * List secrets
 *
 * Returns the list of secrets
 */
export const secretsListSecrets = <ThrowOnError extends boolean = true>(
  options?: Options<SecretsListSecretsData, ThrowOnError>,
): RequestResult<SecretsListSecretsResponses, SecretsListSecretsErrors, ThrowOnError> =>
  (options?.client ?? client).get<SecretsListSecretsResponses, SecretsListSecretsErrors, ThrowOnError>({
    url: "/api/v1/secrets",
    ...options,
  });

/**
 * Create a new secret
 *
 * Creates a new secret
 */
export const secretsCreateSecret = <ThrowOnError extends boolean = true>(
  options: Options<SecretsCreateSecretData, ThrowOnError>,
): RequestResult<SecretsCreateSecretResponses, SecretsCreateSecretErrors, ThrowOnError> =>
  (options.client ?? client).post<SecretsCreateSecretResponses, SecretsCreateSecretErrors, ThrowOnError>({
    url: "/api/v1/secrets",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Deletes a secret
 *
 * Deletes the specified secret
 */
export const secretsDeleteSecret = <ThrowOnError extends boolean = true>(
  options: Options<SecretsDeleteSecretData, ThrowOnError>,
): RequestResult<SecretsDeleteSecretResponses, SecretsDeleteSecretErrors, ThrowOnError> =>
  (options.client ?? client).delete<SecretsDeleteSecretResponses, SecretsDeleteSecretErrors, ThrowOnError>({
    url: "/api/v1/secrets/{idOrName}",
    ...options,
  });

/**
 * Get secret details
 *
 * Returns the details of a specific secret
 */
export const secretsDescribeSecret = <ThrowOnError extends boolean = true>(
  options: Options<SecretsDescribeSecretData, ThrowOnError>,
): RequestResult<SecretsDescribeSecretResponses, SecretsDescribeSecretErrors, ThrowOnError> =>
  (options.client ?? client).get<SecretsDescribeSecretResponses, SecretsDescribeSecretErrors, ThrowOnError>({
    url: "/api/v1/secrets/{idOrName}",
    ...options,
  });

/**
 * Updates a secret
 *
 * Updates the specified secret
 */
export const secretsUpdateSecret = <ThrowOnError extends boolean = true>(
  options: Options<SecretsUpdateSecretData, ThrowOnError>,
): RequestResult<SecretsUpdateSecretResponses, SecretsUpdateSecretErrors, ThrowOnError> =>
  (options.client ?? client).patch<SecretsUpdateSecretResponses, SecretsUpdateSecretErrors, ThrowOnError>({
    url: "/api/v1/secrets/{idOrName}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Remove a key from a secret
 *
 * Removes one key from the secret. Secret must have at least one key remaining.
 */
export const secretsDeleteSecretKey = <ThrowOnError extends boolean = true>(
  options: Options<SecretsDeleteSecretKeyData, ThrowOnError>,
): RequestResult<SecretsDeleteSecretKeyResponses, SecretsDeleteSecretKeyErrors, ThrowOnError> =>
  (options.client ?? client).delete<SecretsDeleteSecretKeyResponses, SecretsDeleteSecretKeyErrors, ThrowOnError>({
    url: "/api/v1/secrets/{idOrName}/keys/{keyName}",
    ...options,
  });

/**
 * Set or overwrite a single key in a secret
 *
 * Sets the value for one key. Creates the key if missing, overwrites if present.
 */
export const secretsSetSecretKey = <ThrowOnError extends boolean = true>(
  options: Options<SecretsSetSecretKeyData, ThrowOnError>,
): RequestResult<SecretsSetSecretKeyResponses, SecretsSetSecretKeyErrors, ThrowOnError> =>
  (options.client ?? client).put<SecretsSetSecretKeyResponses, SecretsSetSecretKeyErrors, ThrowOnError>({
    url: "/api/v1/secrets/{idOrName}/keys/{keyName}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Update secret name
 *
 * Updates only the name of the secret. Name must be unique within the domain.
 */
export const secretsUpdateSecretName = <ThrowOnError extends boolean = true>(
  options: Options<SecretsUpdateSecretNameData, ThrowOnError>,
): RequestResult<SecretsUpdateSecretNameResponses, SecretsUpdateSecretNameErrors, ThrowOnError> =>
  (options.client ?? client).patch<SecretsUpdateSecretNameResponses, SecretsUpdateSecretNameErrors, ThrowOnError>({
    url: "/api/v1/secrets/{idOrName}/name",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * List triggers
 *
 * Returns a list of all available triggers
 */
export const triggersListTriggers = <ThrowOnError extends boolean = true>(
  options?: Options<TriggersListTriggersData, ThrowOnError>,
): RequestResult<TriggersListTriggersResponses, TriggersListTriggersErrors, ThrowOnError> =>
  (options?.client ?? client).get<TriggersListTriggersResponses, TriggersListTriggersErrors, ThrowOnError>({
    url: "/api/v1/triggers",
    ...options,
  });

/**
 * Describe trigger
 *
 * Returns a trigger by its name
 */
export const triggersDescribeTrigger = <ThrowOnError extends boolean = true>(
  options: Options<TriggersDescribeTriggerData, ThrowOnError>,
): RequestResult<TriggersDescribeTriggerResponses, TriggersDescribeTriggerErrors, ThrowOnError> =>
  (options.client ?? client).get<TriggersDescribeTriggerResponses, TriggersDescribeTriggerErrors, ThrowOnError>({
    url: "/api/v1/triggers/{name}",
    ...options,
  });

/**
 * List users
 *
 * Returns all users that have roles within a domain
 */
export const usersListUsers = <ThrowOnError extends boolean = true>(
  options?: Options<UsersListUsersData, ThrowOnError>,
): RequestResult<UsersListUsersResponses, UsersListUsersErrors, ThrowOnError> =>
  (options?.client ?? client).get<UsersListUsersResponses, UsersListUsersErrors, ThrowOnError>({
    url: "/api/v1/users",
    ...options,
  });

/**
 * List widgets
 *
 * Returns a list of all available widgets
 */
export const widgetsListWidgets = <ThrowOnError extends boolean = true>(
  options?: Options<WidgetsListWidgetsData, ThrowOnError>,
): RequestResult<WidgetsListWidgetsResponses, WidgetsListWidgetsErrors, ThrowOnError> =>
  (options?.client ?? client).get<WidgetsListWidgetsResponses, WidgetsListWidgetsErrors, ThrowOnError>({
    url: "/api/v1/widgets",
    ...options,
  });

/**
 * Describe widget
 *
 * Returns a widget by its name
 */
export const widgetsDescribeWidget = <ThrowOnError extends boolean = true>(
  options: Options<WidgetsDescribeWidgetData, ThrowOnError>,
): RequestResult<WidgetsDescribeWidgetResponses, WidgetsDescribeWidgetErrors, ThrowOnError> =>
  (options.client ?? client).get<WidgetsDescribeWidgetResponses, WidgetsDescribeWidgetErrors, ThrowOnError>({
    url: "/api/v1/widgets/{name}",
    ...options,
  });
